export default {
  agents: {
    addAgent: 'Add agent',
    addAgentErrorText: 'An error occurred while adding the agent',
    addAgentSuccessText: 'The new agent has been added successfully',
    addAgentSuccessTitle: 'Agent added',
    addNewAgent: 'Add new agent',
    agentsLabel: 'Agents',
    agentsList: 'Agent list',
    agentsSearchPlaceholder: 'Search for an agent by name',
    assignedCustomers: 'List of assigned customers',
    commission: 'Commission',
    commissions: {
      comissionStatus: {
        PAID: 'Paid',
        TO_PAY: 'To pay'
      },
      commission: 'Commission',
      commissionStatusOption: 'Commission status?',
      errorWhenPayOut: 'An erro occurred during creating payout request',
      invoiceExists: 'Invoice exists?',
      noCommissionsToDisplay: 'No commissions to display',
      orderDate: 'Order date',
      orderName: 'Order name',
      orderStatus: 'Order status',
      paymentStatus: 'Payment status',
      payOut: 'Payout selected',
      settlementNumber: 'Settlement number',
      settlementStatus: {
        PAID: 'Paid',
        UNPAID: 'Unpaid'
      },
      settlementStatusOptions: 'Settlement status?'
    },
    commissionsList: 'Commissions list',
    deleteConfirmTitle: 'Are you sure you want to delete the selected agent?',
    deleteErrorText: 'Failed to delete the agent',
    deleteSuccessText: 'The selected agent has been deleted successfully',
    deleteSuccessTitle: 'Agent deleted',
    editAgent: 'Edit agent',
    editAgentErrorText: 'Failed to update the agent',
    editAgentSuccessText: 'The agent has been updated successfully',
    editAgentSuccessTitle: 'Agent updated',
    noAgentsMatchingPhraseFound: 'No agents matching the entered phrase',
    noAgentsToDisplay: 'No agents to display',
    reportEmail: 'Email for reports',
    selectAgent: 'Select agent',
    sendReport: 'Send reports',
    settlements: {
      currency: 'Currency',
      date: 'Date of payout order',
      deleteConfirmTitle: 'Do you want to undo this payout?',
      deleteErrorText: 'Unable to cancel payout',
      deleteSuccessText: 'Selected payout has been cancelled',
      deleteSuccessTitle: 'Payout cancelled',
      export: 'Export',
      invoicesList: 'List of included invoices',
      noSettlementsToDisplay: 'No payouts to display',
      ordersList: 'List of paid orders',
      quote: 'Quote '
    },
    settlementsHistory: 'Settlements history',
    thisTabWillBeAvailableAfterSavingAgent: 'This tab will be available after saving agent...'
  },
  attachment: {
    addAttachemnt: 'Add attachment',
    attachemnts: 'Attachments',
    chooseFileToAttachOptional: 'Select a file to attach (optional)',
    downloadAttachment: 'Download attachment',
    filesToAttach: 'Files to attach',
    fileToAttach: 'File to attach',
    noAttachment: 'No attachment',
    removeAttachement: 'Delete attachment',
    selectFileWithAttachmentOptional: 'Select file with attachment (optional)'
  },
  calendar: {
    chooseDayToShowOrders: 'Select a day to show the orders',
    chooseSecondDay: 'Choose a second day',
    howManyItemsMove: 'How many pieces to move?',
    moveOrder: 'Move order',
    moveOrderErrorText: 'Updating your order has failed. Please try again.',
    moveOrderPartSuccessTitle: 'Part of the order moved',
    moveOrderSuccessText: 'The selected order has been updated',
    moveOrderSuccessTitle: 'Order moved',
    needToSelectDifferentDates: 'Choose different dates for both days!',
    noOrders: 'No orders',
    noPlannedOrders: 'No planned orders',
    orderChangeUnsuccessful: 'Reorder failed. Please try again.',
    orderUpdateUnsuccessful: 'Updating your order has failed. Please try again.',
    planned: 'Scheduled',
    showCurrentWeek: 'Show current week',
    showToday: 'Show today',
    today: 'Today',
    toWhatDay: 'For which day?'
  },
  complaints: {
    addNewComplaint: 'Add new complaint',
    complainedElements: 'Complained elements',
    complainedProductsCount: 'Complained products',
    complainedServicesCount: 'Complained services',
    complainedShipmentsCount: 'Complained shipments',
    complaint: 'Complaint',
    complaints: 'Complaints',
    complaintsInfoAvailableAfterSave: 'Complaints list will be available after saving the order',
    complaintsList: 'Complaints list',
    createdAt: 'Created',
    createdBy: 'Created by',
    deleteComplaintText: 'This operation cannot be undone',
    ended: 'Ended',
    enterOrderName: 'Enter order name',
    handledBy: 'Handled by',
    inRealization: 'In realization',
    itemsStatusAccepted: 'accepted',
    itemsStatusNegotiated: 'negotiated',
    itemsStatusReceived: 'received',
    itemsStatusRejected: 'rejected',
    noComplaintsToDisplay: 'No complaints to display',
    popup: {
      addComplaint: 'Add complaint',
      addErrorText: 'The complaint has not been added - please try again',
      addSuccessText: 'Complaint added successfully to the order',
      addSuccessTitle: 'Complaint added',
      complainedItems: 'Complained items',
      complainedProducts: 'Complained products',
      complainedServices: 'Complained services',
      complainTransport: 'Complain transport',
      description: 'Complaint description',
      editComplaint: 'Save changes',
      editErrorText: 'An error occurred during modifying the complaint - please try again',
      editSuccessText: 'Complaint modified successfully',
      editSuccessTitle: 'Complaint modified',
      enterComplaintDescription: 'Enter complaint description',
      handler: 'Person who handles this complaint',
      notInOrder: 'Not exists in the order',
      product: 'Product',
      service: 'Service',
      trackingNumber: 'Tracking number'
    },
    removeComplaintConfirmTitle: 'Do you want to remove complaint?',
    removeComplaintErrorText: 'An error occurred during removing the complaint. Please try again.',
    removeComplaintSuccessText: 'The selected complaint has been removed',
    removeComplaintSuccessTitle: 'Complaint removed',
    status: 'Complaint status',
    statuses: 'Elements status',
    statusNames: {
      accepted: 'Accepted',
      negotiated: 'Negotiated',
      received: 'Received',
      rejected: 'Rejected'
    }
  },
  container: {
    addContainer: 'Add a container',
    addContainerErrorText: 'Dodawanie kontenera nie powiodło się. Spróbuj ponownie.',
    addContainerSuccessText: 'Adding a container has failed. Please try again.',
    addContainerSuccessTitle: 'Container added',
    addingNewContainer: 'Adding a new container',
    addNewContainer: 'Add a new container',
    canClose: 'Can it be closed?',
    close: 'Closed',
    closeContainer: 'Close the container',
    container: 'Container',
    containerCloseErrorText: 'Container closure failed. Please try again.',
    containerEdit: 'Edit the container',
    containerNumber: 'Container number',
    containers: 'Containers',
    containerSearchInProgress: 'Searching for containers is in progress',
    containersList: 'List of containers',
    containersOrders: 'Containers - orders',
    dliveryDateChanged: 'The delivery date has been changed',
    editContainer: 'Edit container',
    enterContainerNumber: 'Enter container number or name, product code',
    importResults: 'Import results',
    importSuccessfull: 'Imported successfully',
    noContainersMatchingPhraseFound: 'No containers matching the given phrase',
    noContainersToDisplay: 'No containers to display',
    noContainersWithSufficientProductQuantityFound: 'No containers with sufficient quantities of the selected product were found.',
    noProductsInOrders: 'No products in orders...',
    noProductsInThisContainer: 'No products in this container...',
    notificationSendErrorText: 'Sending notifications has failed. Please try again.',
    notificationSendSuccessText: 'Email notifications have been sent to customers',
    notificationSendSuccessTitle: 'Notifications sent',
    open: 'Open',
    ordersSum: 'Total orders',
    productManagementAvailableAfterContainerSave: 'Product management will be available after saving the container.',
    productsInOrders: 'Products in orders',
    removeContainerConfirmTitle: 'Are you sure you want to delete this container?',
    removeContainerErrorText: 'Removal of container has failed. Please try again.',
    removeContainerSuccessText: 'The selected container has been deleted',
    removeContainerSuccessTitle: 'Container removed',
    removeProductText: 'First remove related products to be able to remove this product from the container',
    reservation: {
      containersReservationsList: 'Booking list from containers',
      noContainersReservationsToDisplay: 'No reservations from containers to be displayed',
      reserevedInContainer: 'Reserved in container',
      reservationsClose: 'Reservations completed',
      reservationsOpen: 'Pending reservations'
    },
    result: 'Result',
    saveOrderToBeAbleToBook: 'Save your order to reserve',
    searchForProductInContainers: 'Search for product in containers',
    selectContainer: 'Select a container',
    sendMessageToCustomers: 'Send a message to customers',
    updateContainerErrorText: 'Container update failed. Please try again.',
    updateContainerSuccessText: 'The specified container has been updated',
    updateContainerSuccessTitle: 'The container has been updated'
  },
  contractor: {
    acceptanceDate: 'Date of acceptance',
    addContractor: 'Add a contractor',
    addContractorErrorText: 'Adding a contractor failed. Please try again.',
    addContractorSuccessText: 'The specified contractor has been saved',
    addContractorSuccessTitle: 'Contractor added',
    addingNewContractor: 'Adding a new contractor',
    addingPricesWillBeAvailableAfterContractorSave: 'Adding prices will be possible after saving the contractor.',
    addNewContractor: 'Add new contractor',
    all: 'All',
    chooseContractor: 'Select a contractor',
    chooseEndedStatus: 'Showy only ended?',
    chooseSettlementStatus: 'Select settlement status',
    contractor: 'Contractor',
    contractorName: 'Contractor name',
    contractors: 'Contractors',
    contractorsList: 'List of contractors',
    dateOfSampleAndAcceptance: 'Date of sample and acceptance',
    doEditContractor: 'Edit the contractor',
    editContractor: 'Edit contractor',
    editContractorErrorText: 'Contractor update failed. Please try again.',
    editContractorSuccessText: 'The specified contractor has been updated',
    editContractorSuccessTitle: 'Contractor updated',
    enterContractorName: 'Enter the name of the contractor',
    listOfContractorsWorksToBeSettled: 'List of contractors\' works to be settled',
    makeSettlementErrorText: 'Settlement failed. Please try again.',
    noContractorsToDisplay: 'No contractors to display',
    noItemsToBeSettled: 'Brak elementów do rozliczenia',
    onlyEnded: 'Only ended',
    removeContractorConfirmTitle: 'Czy na pewno chcesz usunąć tego wykonawcę?',
    removeContractorErrorText: 'Contractor removal failed. Please try again.',
    removeContractorSuccessText: 'The selected contractor has been removed',
    removeContractorSuccessTitle: 'Contractor removed',
    service: 'Service',
    serviceCost: 'Cost of service',
    toBeSettled: 'To be settled',
    unitPrice: 'Unit price'
  },
  contractorsSettlementsImportPopup: {
    importSuccessDesc: 'Data from XLSX file has been imported',
    importSuccessTitle: 'Data imported',
    importTitle: 'Import list of contractors\' works to be settled',
    importXlsx: 'Import XLSX',
    xlsxFile: 'XLSX file'
  },
  customer: {
    addAddress: 'Add address',
    addAddressByTaxInfoSuccessText: 'New shipping address has been added (based on tax info) due lack of other shipping addresses',
    addAddressByTaxInfoSuccessTitle: 'Shipping address added',
    addAddressErrorText: 'Address addition failed. Please try again.',
    addAddressSuccessText: 'The specified address has been saved',
    addAddressSuccessTitle: 'Address added',
    addContactPerson: 'Add contact person',
    addContactPersonErrorText: 'Adding a contact person has failed. Please try again.',
    addContactPersonSuccessText: 'The specified contact person has been saved',
    addContactPersonSuccessTitle: 'Added contact person',
    addCustomer: 'Add customer',
    addCustomerErrorText: 'Adding a customer has failed. Please try again.',
    addCustomerSuccessText: 'The specified customer has been saved',
    addCustomerSuccessTitle: 'Customer added',
    addingContactPersonAvailableAfterCustomerSave: 'Adding contact persons will be possible after saving the customer.',
    addingNewCustomer: 'Adding a new customer',
    addingPricesWillBeAvailableAfterContractorSave: 'Adding prices will be possible after saving the customer.',
    addingShippingAddressAvailableAfterCustomerSave: 'Adding shipping addresses will be possible after saving the customer.',
    addingTransaltionsAvailableAfterCustomerSave: 'Adding translations will be possible after saving the customer.',
    addNewCustomer: 'Add new customer',
    addressCreateFrom: 'Create address based on',
    autoSpecialRequirements: 'Enable special requirements automatically',
    building: 'Building',
    buildingNumber: 'Building number',
    changePassword: 'Change password',
    changeYourPassword: 'Change your password',
    city: 'City',
    company: 'Company',
    companyName: 'Company name',
    contact: {
      addComment: 'Add comment',
      addContactErrorText: 'Adding a customer contact has failed. Please try again.',
      addContactSuccessText: 'The specified customer contact has been saved',
      addContactSuccessTitle: 'Customer contact added',
      addNewCustomerContact: 'Add a new customer contact',
      addNewLabel: 'Add customer contact',
      addNewTitle: 'Adding a new customer contact',
      author: 'Author',
      commentContent: 'Comment content',
      comments: 'Comments',
      contact: 'Contact',
      contactDate: 'Contact date',
      contactRelatedToContact: 'Customer contact person (optional)',
      contactRelatedToOrder: 'Contact regarding your order (optional)',
      contactType: 'Type of contact',
      contactTypeQuestionMark: 'Contact type?',
      content: 'Content',
      customerContactsList: 'List of customer contacts',
      customerResponse: 'Customer response',
      customersContacts: 'Contacts with customers',
      customersContactsList: 'List of customers contacts',
      descriptionOptional: 'Description (optional)',
      editComment: 'Edit comment',
      editContactErrorText: 'Saving customer contact failed. Please try again.',
      editContactSuccessText: 'Selected customer contact has been saved',
      editContactSuccessTitle: 'Customer contact saved',
      editTitle: 'Edit customer contact',
      mailContact: 'Email contact',
      noCommentsToDisplay: 'No comments to display',
      noContactsToDisplay: 'No contacts to display',
      noResponse: 'no response',
      notifications: 'Related notifications',
      notificationsWillBeAvailableAfterSaving: 'Related notifications will be visible after saving contact with customer',
      phoneContact: 'Telephone contact',
      removeCommentConfirmTitle: 'Are you sure you want to delete this comment?',
      removeCommentErrorText: 'Removal of comment has failed. Please try again.',
      removeCommentSuccessText: 'The selected comment has been removed',
      removeCommentSuccessTitle: 'Comment removed',
      removeContactConfirmTitle: 'Are you sure you want to delete this contact?',
      removeContactErrorText: 'Contact deletion failed. Please try again.',
      removeContactSuccessText: 'The selected contact has been deleted',
      removeContactSuccessTitle: 'Contact removed',
      repliedOn: 'Replied on',
      saveCommentErrorText: 'Saving comment failed. Please try again.',
      saveCommentSuccessText: 'Comment has been successfully saved',
      saveCommentSuccessTitle: 'Comment saved',
      saveContactErrorText: 'Saving a customer contact has failed. Please try again.',
      saveContactSuccessText: 'The specified customer contact has been saved',
      saveContactSuccessTitle: 'Customer contact saved',
      type: 'Type',
      typeMail: 'Email',
      typeMeeting: 'Meeting',
      typePatternSending: 'Shipment of patterns',
      typePhone: 'Telephone',
      typeSpecCatSending: 'Shipment \"spec cap\"'
    },
    contactAddress: 'Contact address',
    contactGroupQuestionMark: 'Kind of contact?',
    contactInsideOrder: 'Contact in order',
    contactPeople: 'Contact persons',
    contactsWithCustomer: 'Contacts with the customer',
    correspondenceAddressSet: 'Correspondence address has been set',
    correspondenceAddressSetDesc: 'According to the downloaded data the correspondence address of the customer has been set',
    correspondenceAddressWillBeUsed: 'Correspondence address of the customer will be used to create new shipping address',
    correspondenceInfo: 'Correspondence details',
    createAddressCorrespondence: 'Correspondence address',
    createAddressInvoice: 'Invoice address',
    createNewAddress: 'New address',
    customerCode: 'Customer code',
    customerContactsInfoAvailableAfterSave: 'Customer contact data will be available after saving the order',
    customerContactsInforAvailableAfterCustomerSave: 'Customer contact data will be available when the customer is saved',
    customerCountryQuestionMark: 'Customer country?',
    customerLogo: 'Customer logo',
    customerLowCase: 'customers',
    customers: 'Customers',
    customersList: 'List of customers',
    customerTags: 'Customer tags',
    dayForPayment: 'Days for payment',
    deleteAddressConfirmTitle: 'Are you sure you want to delete this address?',
    deleteAddressErrorText: 'Address deletion failed. Please try again.',
    deleteAddressSuccessText: 'The selected address has been deleted',
    deleteAddressSuccessTitle: 'Address removed',
    deleteContactPersonConfirmTitle: 'Are you sure you want to delete this contact person?',
    deleteContactPersonErrorText: 'Deleting a contact person has failed. Please try again.',
    deleteContactPersonSuccessText: 'The selected contact person has been deleted',
    deleteContactPersonSuccessTitle: 'Contact person removed',
    discount: {
      currentCustomerDiscounts: 'Current customer discounts',
      currentCustomerDiscountsDifferentFromThoseInOrder: '<strong>Attention!</strong> The customer\'s current discounts differ from those applied in the order.',
      deliveryDiscount: 'Delivery discount',
      discounts: 'Discounts',
      discountsUpdateErrorText: 'Discount change has failed. Try again.',
      editCustomerDiscounts: 'Edit customer discounts',
      includeCustomerDiscounts: 'Include customer discounts',
      modifyCustomerDiscounts: 'Modify customer discounts',
      productDiscount: 'Product discount',
      resetDiscounts: 'Change discounts',
      resetDiscoutns: 'Reset discounts',
      resetOrderDiscountsText: 'The discount values ​​in the order will be set according to the current customer discounts. Do you want to continue?',
      resetOrderDiscountsTitle: 'Change of discounts',
      serviceDiscount: 'Service discount',
      servicesDiscount: 'Discount on services',
      shippingDiscount: 'Shipping discount'
    },
    discountRange: 'Discount range',
    donNotSend: 'Don\'t send',
    downloadTaxNumberConfirmation: 'Download confirmation',
    downloadTaxNumberConfirmationAfterSave: 'Confirmation can be downloaded after saving customer',
    downloadTaxNumberConfirmationDownloading: 'Downloading confirmation...',
    edit: 'Edit the customer',
    editAddress: 'Edit the address',
    editAddressErrorText: 'Editing of the address failed. Try again.',
    editAddressSuccessText: 'The given address has been changed',
    editAddressSuccessTitle: 'Address changed',
    editClientErrorText: 'Editing the customer failed. Try again.',
    editClientSuccessText: 'Customer details have been modified',
    editClientSuccessTitle: 'Customer modified',
    editContactPerson: 'Edit the contact person',
    editContactPersonErrorText: 'Editing contact person failed. Try again.',
    editContactPersonSuccessText: 'The specified contact person has been changed',
    editContactPersonSuccessTitle: 'Contact person has been changed',
    editPasswordErrorText: 'Password change failed. Please try again.',
    editPasswordSuccessText: 'The password has been changed',
    editPasswordSuccessTitle: 'Password changed',
    enterCustomerAddress: 'Enter customer city',
    enterCustomerData: 'Enter customer details',
    excludeFromInvoiceReminder: 'Exclude from invoice reminders',
    excludeFromStockReports: 'Exclude from stock reports',
    exportCustomers: 'Export customers',
    exportPricesInfo: 'All product prices connected with this customer will be exported.',
    fountAddresses: 'Addresses found:',
    getDataFromGUS: 'Get data from GUS',
    getDataFromVIES: 'Get data from VIES',
    hidecustomerInQR: 'Hide customer data in QR code',
    history: 'Edit history',
    historyAction: 'Change type',
    historyActions: 'Actions',
    historyActionsList: {
      ADD: 'Add',
      DELETE: 'Deletion',
      UPDATE: 'Modification'
    },
    historyDate: 'Date',
    historyDiffPopup: {
      currentValue: 'Current value',
      fieldName: 'Field name',
      previousValue: 'Previous value',
      title: 'Applied changes'
    },
    historyInfoAvailableAfterSave: 'History data will be available when the offer is saved',
    historyModifiedElement: 'Modified element',
    historyModifiedElementsList: {
      ADDRESS: 'Address data',
      CONTACT: 'Contact data',
      CUSTOMER: 'Customer data',
      PRODUCT_PRICE: 'Product prices',
      TAX_NUMBER_VERIFICATION: 'Tax ID verification',
      TRANSLATION: 'Translations'
    },
    historyNoRecords: 'No history of edition for this customer',
    historySeeChanges: 'See changes',
    historyUser: 'Change made by',
    historyWillBeAvailableAfterCustomerSave: 'History data will be available after customer save',
    houseNumber: 'Premises number',
    inactiveTaxNumberLong: 'Inactive NIP/VAT ID for the selected customer. The order cannot be added.',
    indentDiscountEnabled: 'Discounts enabled by default in the Indent orders/offers',
    invalidTaxNumber: 'Invalid tax number',
    invalidTaxNumberLong: 'Invalid tax number',
    invalidTaxNumberLong2: 'Invalid tax number for the selected customer. The order cannot be added.',
    invoiceAddressSet: 'Invoice data has been set',
    invoiceAddressSetDesc: 'According to the downloaded data the invoice data of the customer has been set',
    invoiceAddressWillBeUsed: 'Address used on invoices of the customer will be used to create new shipping address',
    invoiceAndCorrespondenceAddressSet: 'Invoice data and correspondence address has been set',
    invoiceAndCorrespondenceAddressSetDesc: 'According to the downloaded data the invoice data and the correspondence address of the customer has been set',
    invoiceInfo: 'Invoice details',
    invoiceName: 'Name on invoice',
    invoiceReceiver: 'Invoice recipient',
    invoiceReceiverEmailAddress: 'Invoice recipient\'s e-mail address',
    isInvoicesNotSettled: 'Unsettled invoices?',
    isOrdersInRpogress: 'Orders in progress?',
    lastTaxVerification: 'Last tax number verification date:',
    maxAddressSearchResults: 'A maximum of 50 matching addresses are displayed, if you cannot find the address you need - narrow down your search.',
    nameNotice: 'Set in: Invoice details → Name on invoice',
    newsletterAgreement: 'Newsletter consent',
    newsletterStatus: {
      null: 'No information',
      subscribed: 'Consent given',
      unsubscribed: 'No consent'
    },
    newsletterStatusAt: 'Last consent change for newsletter',
    noAddressesToDisplay: 'No addresses to display',
    noContactPeopleToDisplay: 'No contact persons to display',
    noCustomerMarchingPhraseFound: 'No customers that match the given phrase',
    noCustomersToDisplay: 'No customers to display',
    noTagsMatchingGivenPhrase: 'No tags matching given phrase',
    noTranslationsForThisClient: 'No translations for this customer',
    offersInProgress: 'Offers in progress',
    orders: 'Orders',
    ordersAndOffers: 'Orders and offers',
    ordersInProgress: 'Orders in progress',
    passowrdChange: 'Password change',
    person: 'Person',
    phoneShortCap: 'Tel',
    product: 'Product',
    profile: 'Profile',
    removeCustomerConfirmTitle: 'Are you sure you want to delete this customer?',
    removeCustomerErrorText: 'Customer deletion failed. Please try again.',
    removeCustomerSuccessText: 'The selected customer has been deleted',
    removeCustomerSuccessTitle: 'Customer removed',
    removeLogo: 'Remove logo',
    retrievedStatus: 'Retrieved status:',
    retrievedStatusFor: 'for: ',
    searchAddressesByCompanyNameAddressOrContactInfo: 'Search for addresses by company name, address or contact details',
    selectCustomer: 'Select a customer',
    selectDiscountType: 'Select discount type',
    selectDiscountTypes: {
      discountProducts: 'Products discount',
      discountServices: 'Services discount',
      discountShipping: 'Shipping discount'
    },
    selectMarketCustomer: 'Select a market customer',
    selectPotentialCustomer: 'Select a potential customer',
    sendCommunication: 'Send communication?',
    sendReportFromStock: 'Send report form stocks',
    setInvoiceDataAsCorrespondenceData: 'Use invoice data as correspondence data',
    shippingInfo: 'Shipping details',
    showCustomerOffers: 'Show offers',
    showCustomerOrders: 'Show orders',
    sourceOfGain: 'Source of acquisition',
    statistics: 'Statistics',
    stockReportsNotifications: 'Stock notifications',
    street: 'Street',
    taxNumberConfirmationFileNamePrefix: 'vat-id-customer-',
    taxNumberDifference: 'Provided number is different than lastly verified tax number',
    telephone: 'Telephone',
    termsOfSale: 'Terms of sale',
    termsOfSaleIndent: 'Terms of sale Indent',
    unsettledInvoices: 'Unsettled invoices',
    validTaxNumber: 'Valid tax number',
    vatIDActiveDuringCheck: 'Active during check',
    vatIDNumber: 'NIP / VAT ID',
    verificationGusErrorDesc: 'GUS returned invalid status for customer NIP. Please manually check customer data.',
    verificationGusErrorTitle: 'Verification in GUS failed',
    verificationIntegrationDisabledDesc: 'It will be automatically enabled soon, and the customer NIP/VAT ID will be verified.',
    verificationIntegrationDisabledTitle: 'VIES/GUS integration is disabled',
    verificationOtherErrorDesc: 'System returned invalid status for customer NIP/VAT ID. Please manually check customer data.',
    verificationOtherErrorTitle: 'Data verification failed',
    verificationSkippedDesc: 'For this customer verification is skipped due country, system configuration or disabled integration with tax number verification service.',
    verificationSkippedTitle: 'Verification skipped',
    verificationViesErrorDesc: 'VIES returned invalid status for customer VAT ID. Please manually check customer data.',
    verificationViesErrorTitle: 'Verification in VIES failed',
    verifyManually: 'Zweryfikuj ręcznie',
    verifyTaxID: 'Verify',
    viesCommunicationIssue: 'An error occurred during communication with VIES and system is unable to check VAT number.',
    viesVerifiedManuallyDesc: 'VAT number has been manually verified',
    viesVerifiedManuallyTitle: 'Verified manually',
    weakCustomer: 'Weak customer',
    withOrdersInProgress: 'With orders in progress',
    withoutOrdersInProgress: 'Without orders in progress',
    withoutUnsettledInvoices: 'Without unpaid invoices',
    withUnsettledInvoices: 'With unpaid invoices',
    youMustCheckCurrentTaxIDDesc: 'Currently used NIP/VAT ID was not checked in VIES/GUS - please verify the number and try again.',
    youMustCheckTaxID: 'Non-verified NIP/VAT ID',
    youMustCheckTaxIDDesc: 'Before adding customer, you must verify his NIP/VAT ID. If NIP / VAT ID has been changed - check data in VIES/GUS again before saving.',
    youMustProvideTaxNumberDesc: 'Before adding customer, you must enter his tax number',
    youMustProvideTaxNumberTitle: 'You must enter tax number',
    youMustProvideValidTaxNumberDesc: 'Entered tax number is invalid or inactive. It is impossible to add customer without providing valid and active tax number.',
    youMustProvideValidTaxNumberTitle: 'Invalid tax number',
    youMustSelectCountryPrefix: 'Lack of country code',
    youMustSelectCountryPrefixDesc: 'Before NIP/VAT ID verification you must select country code',
    youMustSelectCountryPrefixDesc2: 'To NIP/VAT ID verification before adding order, the country code is necessary, but it is not specified for the selected customer',
    yourAccount: 'Your account',
    zipCode: 'Postal code'
  },
  customerOrdersPopup: {
    offers: 'Customer offers',
    orders: 'Customer orders'
  },
  dashboard: {
    admin_new_contacts_count: 'Contacts to acquire',
    admin_new_customers_count: 'Customers to acquire',
    approachingDeadline: 'Deadline is approaching',
    awaitingDraft: 'Awaiting draft',
    awaitingProductionFinish: 'Awaiting completion of production',
    awaitingSample: 'Awaiting sample',
    awaitingSampleAccept: 'Awaiting sample approval',
    blockedOrders: 'Blocked orders',
    checkOffers: 'Check offers',
    customersPopup: {
      averageOrderTime: 'Usually create order after {days} days',
      customerEmail: 'E-mail',
      customerName: 'Customer name',
      customerPhone: 'Phone',
      title: 'Send inquiries to customers'
    },
    finishingProduction: 'Finishing production',
    from: ' from ',
    inPreprationForShipping: 'Preparation for shipment',
    inquiriesToSendToCustomers: 'Inquiries to send',
    inquiruesPendingCustomerResponse: 'Offers awaiting customer response',
    longRealizedOrders: 'Orders with long realization',
    mainPage: 'Homepage',
    myTasksTitle: 'My tasks',
    new_contacts_count: 'Acquire contacts',
    new_customers_count: 'Acquire customers',
    offersToCheck: 'Offers to check',
    ordersInProduction: 'Orders in production',
    ordersInWarehouse: 'Orders collected in warehouse',
    ordersPendingInvoice: 'Orders awaiting invoice',
    ordersPendingShipment: 'Orders awaiting shipment',
    orderStatsTitle: 'Order stats',
    sendInquiriesToCustomers: 'Send inquiries',
    showCustomers: 'Show customers',
    showOffers: 'Show offers',
    toSettleWithContractors: 'To be settled with contractors',
    welcomeToHeadwear: 'Welcome to HeadWear CRM',
    workersTasksTitle: 'Tasks for workers'
  },
  errorPage: {
    errorCode: '404',
    pageDoesNotExist: 'The selected subpage does not exist',
    tryAgainLaterOrContactAdministrator: 'Try again later or contact your system administrator.'
  },
  image: {
    dropPhotosHere: 'Drop images here...',
    photo: 'Image',
    photoGallery: 'Image gallery',
    photosLoading: 'Images loading in progress',
    photosOrderChangeErrorText: 'Changing the order of images failed. Please try again.',
    removePhoto: 'Delete image',
    removePhotoConfirmTitle: 'Are you sure you want to delete this image?',
    removePhotoErrorText: 'Deletion of image failed. Please try again.',
    removePhotoSuccessText: 'The selected image has been deleted',
    removePhotoSuccessTitle: 'Image removed',
    webGallery: 'Images for WWW'
  },
  indentRegistry: {
    additionalInfo: 'Additional info',
    addProductPopup: {
      addProduct: 'Add Indent product',
      loadingDataError: 'An error occurred during loading data',
      title: 'Adding new Indent product'
    },
    cnCode: 'CN code',
    code: 'Style',
    customerDesignName: 'Customer order name',
    customerOrderDate: 'Customer order date',
    customerOrderName: 'Customer order number',
    enterOrderName: 'Enter order name',
    exportRegistry: 'Eksport registry',
    freightType: 'Freight type',
    hideDetails: 'Hide details',
    indent: 'Indent',
    indentRegistry: 'Indent registry',
    indentRegistryLowerCase: 'indent-products-registry',
    noItemsToDisplay: 'No items to display',
    order: 'Order',
    orderIndentDatawillBeAvailableAfterSave: 'Indent data will be available after saving order',
    originalShipmentDate: 'Date of shipment from China',
    product: 'Product',
    productAdditionalData: 'Product details',
    products: 'Products',
    productsRegistry: 'Indent products registry',
    quantity: 'Quantity',
    registry: 'Registry',
    sampleProductionDays: 'Sample production time (in days)',
    selectFreightType: 'Select freight type',
    selectRegistry: 'Select Indent registry',
    sellPrice: 'Sell price to customer',
    service: 'Services',
    serviceAcceptedAt: 'Service accepted by customer at',
    serviceObtainingAt: 'Service samples obtained at',
    shipperDate: 'Expected production date',
    shipping: 'Shipping',
    showDetails: 'Show details',
    theseInformationsWillBeUpdatedAfterSave: 'Informations in this tab are updated after order saving',
    timeframeProduction: 'Order production time (w days)',
    title: 'Indent registry',
    unitSellPrice: 'Unit price'
  },
  inquiries: {
    acceptOffer: 'Accept the offer',
    addComments: 'Add your comments',
    addFirstProductInstructionInfo: 'Add your first product by clicking \"Add product\"',
    addInquiry: 'Add an inquiry',
    addMoreProductsInstructionInfo: 'You have added the first product to the inquiry. If you want to add another product, use the \"Add product\" button in the list below. You can search for products for each item by clicking \"Search\".',
    addOfferErrorText: 'Adding an offer has failed. Please try again.',
    addOfferSccessTitle: 'Offer added',
    addOfferSuccessText: 'The given offer has been added',
    addServiceToInquiry: 'Add service to your inquiry',
    attachFilesInfo: 'You can attach additional visualisations to your inquiry to help analyse and price it.',
    caanotCreateOrder: 'Unable to create order',
    combineModelInQuote: 'Combine models in pricing',
    contactUsIfYouNeedToChangeInquiry: 'JIf you need to modify your inquiry/order - please contact us directly.',
    editOfferErrorText: 'Editing your offer has failed. Please try again.',
    editOfferSuccessText: 'The given offer has been modified',
    editOfferSuccessTitleShort: 'The offer has been saved',
    failedToAddProductsToOrder: 'No products have been added to your order',
    followUpSent: 'Follow up sent',
    followUpSentText: 'Reminder to customer has been sent',
    inquiriy: 'Inquiry',
    inquiryAcceptErrorText: 'Accepting an offer has failed. Please try again.',
    inquiryAcceptSuccessText: 'The selected offer has been accepted',
    inquiryAcceptSuccessTitle: 'The offer has been accepted',
    inquiryForProductsNumberRange: 'Query for number of products',
    inquirySaveErrorText: 'Adding an inquiry has failed. Please try again.',
    inquirySaveSccessTitle: 'The inquiry has been saved',
    inquirySaveSuccessText: 'Your inquiry has been saved',
    inquiryStatus: 'Offer status',
    needExecutionTill: 'I need realization by the day',
    noComments: 'No comments',
    noDateSelected: 'No deadline',
    offerDative: 'offer',
    offerDativeCap: 'Offer',
    orderAdditionalInfo: 'Additional order notes',
    sendFollowUp: 'Send follow up',
    sendForCustomerApproval: 'Send for customer approval',
    sendForCustomerApprovalErrorText: 'Sending for customer approval failed. Please try again.',
    sendForCustomerApprovalSuccessText: 'The offer has been sent for customer approval.',
    sendForCustomerApprovalSuccessTitle: 'Sent to customer',
    sendInquiry: 'Send inquiry',
    sendOrder: 'Send order',
    someProductAreUnavailable: 'Some products in your order are not available or are available in too small a quantity to create an order.',
    unexpectedErrorOccured: 'An unexpected problem has occurred',
    yourOrderContainsDecorationsSoSendInquiry: 'Your order includes services. In such a situation, please send an inquiry.'
  },
  kpi: {
    addKpi: 'Add KPI',
    addKpiErrorText: 'Adding KPIs has failed. Please try again.',
    addKpiSuccessText: 'The specified KPI has been saved',
    addKpiSuccessTitle: 'KPI added',
    addNewKpi: 'Add new KPI',
    addNewWorkerGoal: 'Adding a new employee goal',
    amountOfStartedOrders: 'Amount of orders started',
    averageResults: 'Average results',
    contactsNumberRegardingNewOrders: 'Number of contacts regarding new orders',
    editKpiErrorText: 'KPI modification failed. Please try again.',
    editKpiSuccessText: 'The selected KPI has been modified',
    editKpiSuccessTitle: 'KPI have been modified',
    editWorkerGoal: 'Editing the employee\'s goal',
    goals: 'Goals',
    kpiImplementation: 'Achievement of KPI',
    mean: 'AVERAGE',
    noUserSelectedKpiErrorText: 'You must select an employee related to this KPI',
    noWorkersGoalsToDisplay: 'No employee targets to display',
    numberOfNewContacts: 'Number of new contacts acquired',
    numberOfNewCustomers: 'Number of new customers acquired',
    numberOfStartedOffers: 'Number of offers started',
    numberOfStartedOrders: 'Number of orders started',
    onAvergae: 'On average',
    period: 'Period',
    removeGoalConfirmTitle: 'Are you sure you want to delete this KPI target?',
    removeGoalErrorText: 'KPI target deletion failed. Please try again.',
    removeGoalSuccessText: 'The selected employee KPI target has been deleted',
    removeGoalSuccessTitle: 'KPI target deleted',
    sum: 'SUM',
    workersGoals: 'Employee goals',
    workersGoalsList: 'List of employee KPIs'
  },
  login: {
    authError: 'Authorization error. Please try again',
    customerPanelInfo: 'Customer panel has been moved. Contact with us to get access to the new customer panel.',
    emailPlaceholder: 'Your e-mail address',
    loginInProgress: 'Logging in...',
    loginLabel: 'Log in',
    password: 'Password',
    passwordPlaceholder: '********'
  },
  longRealizedOrdersPopup: {
    created: 'Created',
    modified: 'Modified',
    order: 'Order',
    status: 'Status',
    title: 'Orders with long realization'
  },
  marketCustomers: {
    accountManager: 'Account manager',
    addCustomerErrorText: 'An error occurred during adding customer. Please try again.',
    addCustomerSuccessText: 'Market customer successfully added',
    addCustomerSuccessTitle: 'Customer added',
    addNewContact: 'Add new contact',
    addNewMarketCustomer: 'Add new customer',
    addNewMarketCustomerContact: 'Add contact with market customer',
    address: 'Address',
    building: 'Building',
    city: 'City',
    contactName: 'Name',
    contacts: 'Contacts with market customer',
    contactSurname: 'Surname',
    contactsWillBeAvailableAfterSavingMarketCustomer: 'Contacts will be available after saving market customer',
    country: 'Country',
    createCustomerFromMarketCustomer: 'Transform into customer',
    customerExistsDesc: 'Customer with such Tax ID exists. There is no need to add it again.',
    customerExistsTitle: 'Such customer exists',
    dataLoadedCorrectlyDesc: 'Successfully loaded market customer data',
    dataLoadedCorrectlyTitle: 'Data loaded',
    deleteConfirmTitle: 'Do you really want to remove customer?',
    deleteErrorText: 'An error occurred during customer removal. Please try again.',
    deleteSuccessText: 'Market customer successfully removed',
    deleteSuccessTitle: 'Customer removed',
    description: 'Description',
    editCustomerErrorText: 'An error occurred during customer edit. Please try again.',
    editCustomerSuccessText: 'Market customer successfully modified',
    editCustomerSuccessTitle: 'Customer saved',
    email: 'E-mail',
    emptyTaxDataDesc: 'Before creating customer, you must provide VAT prefix and tax number, then save market customer.',
    emptyTaxDataTitle: 'Lack of required data',
    errorLoadingData: 'An error occurred during loading market customer data',
    existingCustomerDesc: 'Customer connected with this tax number exists. If you have changed tax number - remember about saving customer before conversion.',
    existingCustomerTitle: 'Such customer exists',
    importHistory: 'Import history',
    importMarketCustomers: 'Import customers',
    invoiceCountryPrefix: 'VAT Prefix',
    invoiceTaxNumber: 'VAT ID/NIP number',
    locale: 'Locale',
    marketCustomer: 'Market customer',
    marketCustomerEdit: 'Edit market customer',
    marketCustomerNew: 'New market customer',
    marketCustomersLabel: 'Market customers',
    marketCustomersList: 'List of market customers',
    marketCustomersSearchPlaceholder: 'Enter customer name',
    marketCustomersTagPlaceholder: 'Enter customer tag',
    noMarketCustomersToDisplay: 'No market customers to display',
    otherData: 'Additional information',
    phone: 'Phone',
    postCode: 'Postal code',
    saveMarketCustomer: 'Save market customer',
    shopUrl: 'Shop URL',
    tag: 'Customer tag',
    websiteUrl: 'Website URL'
  },
  marketCustomersImportPopup: {
    errorWhileLoadingImportsList: 'An error occurred during loading imports history...',
    importDeleteConfirmTitle: 'Do you really want to remove data form this import?',
    importHistoryIsEmpty: 'No imports to display',
    importHistoryTitle: 'History of the last imports',
    importList: {
      author: 'Imported by',
      count: 'Contacts count',
      date: 'Import date',
      delete: 'Delete'
    },
    importRemoveErrorText: 'An error occurred during removing import data',
    importRemoveSuccessText: 'Import data has been successfully removed',
    importRemoveSuccessTitle: 'Import removed',
    importSuccessDesc: 'Market customers successfully imported',
    importSuccessTitle: 'Import finished',
    importTitle: 'Import market customers',
    xlsxFile: 'Select XLSX file'
  },
  marketing: {
    addingTranslationsAvailableAfterMailingSave: 'Save the message to add translations',
    addMailingErrorText: 'Failed to add message. Please try again.',
    addMailingSuccessText: 'The message has been successfully added.',
    addMailingSuccessTitle: 'Email message added',
    addMessage: 'Add email message',
    addNewMessage: 'Add new message',
    addNewSegment: 'Add new segment',
    addSegment: 'Add segment',
    addSegmentErrorText: 'Failed to add the segment. Please try again.',
    addSegmentSuccessText: 'The specified segment has been added',
    addSegmentSuccessTitle: 'Segment added',
    addTranslation: 'Add translation',
    atLeastOneFilterRequired: 'At least one filter is required.',
    availableVariablesInfo: 'You can use the following tags to personalize the message',
    choose: 'Choose...',
    chooseOnCalendar: 'Choose from calendar',
    customersOrderBy: 'Sort customers by',
    daysAgo: 'days ago',
    editEmailMessage: 'Edit email message',
    editMailingErrorText: 'Failed to edit the message. Please try again.',
    editMailingSuccessText: 'The selected message has been successfully updated.',
    editMailingSuccessTitle: 'Email message updated',
    editSegment: 'Edit segment',
    emailMessages: 'Email messages',
    emailsCount: 'Emails sent',
    emailSubject: 'Email subject',
    enterValue: 'Enter value...',
    exportClientsList: 'Export clients list',
    filtersCount: 'Number of filters',
    howManyDaysAgo: 'How many days ago',
    insertMessageContent: 'Enter message content...',
    listGenerationDate: 'List generation date',
    mailingCannotBeSent: 'Sending the message to customers is disabled.',
    mailingCannotBeUpdated: 'This message cannot be edited right now.',
    mailingNotSentYet: 'The mailing has not been sent yet. The email list will be available after sending starts.',
    maxCustomers: 'Customer limit',
    maxCustomersTable: 'Max customers',
    messageContent: 'Message content',
    newEmailMessage: 'New email message',
    newSegment: 'New segment',
    noMatchingCustomersFound: 'No matching customers found',
    noMessagesToDisplay: 'No messages to display',
    noSegmentsToDisplay: 'No segments to display',
    numberRange: 'Number range',
    ordersAmount: 'Order amount',
    ordersCount: 'Number of orders',
    preview10Results: 'Preview 10 results',
    rebuildClientsList: 'Rebuild clients list',
    reloadClientsList: 'Reload clients list',
    removeMailingConfirmTitle: 'Are you sure you want to delete this message?',
    removeMailingErrorText: 'Failed to delete the message. Please try again.',
    removeMailingSuccessText: 'The selected email message has been deleted.',
    removeMailingSuccessTitle: 'Message deleted',
    removeSegmentConfirmTitle: 'Are you sure you want to remove this segment?',
    removeSegmentErrorText: 'Failed to remove the segment. Please try again.',
    removeSegmentSuccessText: 'The selected segment has been removed',
    removeSegmentSuccessTitle: 'Segment removed',
    resultsPreview: 'Results preview',
    salesTools: 'Sales tools',
    saveAndClose: 'Save and close',
    segmentFilters: 'Segment filters',
    segmentFormValidationError: 'Form validation error. Please create a valid segment to load customer data.',
    segments: 'Segments',
    segmentsCount: 'Segments count',
    sendMailing: 'Send to customers',
    sendMailingConfirmText: '<strong>Warning:</strong> Please make sure you have saved all changes before sending! Unsaved form changes will not be included.<br><br>Are you sure you want to start sending to customers?',
    sendMailingConfirmTitle: 'Are you sure you want to send this mailing?',
    sendMailingErrorText: 'An error occurred while queuing the mailing. Please try again.',
    sendMailingSuccessText: 'The mailing has been added to the sending queue.',
    sendMailingSuccessTitle: 'Sending started',
    sendTestEmail: 'Send test email',
    sentAt: 'Sent at',
    sentEmails: 'Sent emails',
    subject: 'Subject',
    testEmailAddress: 'Test email address',
    testEmailErrorText: 'Failed to send the test email. Please check the email address and try again.',
    testEmailSuccessText: 'The test email has been successfully sent to the provided address.',
    testEmailSuccessTitle: 'Test email sent',
    translations: 'Translations'
  },
  noPermissions: {
    noPermissionsDescription: 'If you think this is an error - please contact your system administrator.',
    noPermissionsText: 'You are not authorised to view this page',
    noPermissionsTitle: 'No permission'
  },
  notifications: {
    addNewNotification: 'Add new notification',
    completedFilterAll: 'All',
    completedFilterIsCompleted: 'Completed',
    completedFilterIsNotCompleted: 'Not completed',
    dateTime: 'Datetime',
    description: 'Notification content',
    editNotification: 'Edit notification',
    form: {
      addCC: 'Add CC address',
      addNotificationErrorText: 'An error occurred during adding notification. Please try again.',
      addNotificationSuccessText: 'Notification successfully added',
      addNotificationSuccessTitle: 'Notification added',
      date: 'Date',
      description: 'Notification content',
      editNotificationErrorText: 'An error occurred during editing notification. Please try again.',
      editNotificationSuccessText: 'Notification successfully modified',
      editNotificationSuccessTitle: 'Notification modified',
      emailCarbonCopy: 'Who should also receive this notification e-mail (CC)?',
      frequency: 'Frequency',
      frequencyValues: {
        daily: 'Every day',
        monthly: 'Every month',
        selectValue: 'Select',
        weekly: 'Every week'
      },
      isRepeatable: 'Repeatable?',
      reminderBefore: 'How many hours before you want to receive reminder about notification?',
      repeatNumber: 'Repeat number',
      repeatNumberNote: '0 means infinite repeats',
      sendReminder: 'Send e-mail',
      showInDashboard: 'Show on dashboard',
      time: 'Time'
    },
    goToFullList: 'Go to full list',
    hideChildrenNotifications: 'Hide repeat notifications',
    isConnectedWithContact: 'This notification is connected with customer contact',
    markAsCompleted: 'Mark as completed',
    markAsNotCompleted: 'Mark as not completed',
    markingFailedTryAgain: 'Marking notification failed. Please try again.',
    noNotificationsToDisplay: 'No notifications to display',
    notifications: 'Your notifications',
    notificationsLabel: 'Notifications',
    notificationsNearest: 'Your nearest events',
    onlyFutureFilter: 'Only future',
    order: 'Order',
    reminderBefore: 'Reminder',
    removeNotificationConfirmTitle: 'Do you really want to remove this notification?',
    removeNotificationErrorText: 'An error occurred during removing the notification. Please try again.',
    removeNotificationSuccessText: 'Selected notification has been removed',
    removeNotificationSuccessTitle: 'Notification removed',
    seeList: 'See list',
    sendReminder: 'E-mail',
    showAllFilter: 'Show all',
    showChildrenNotifications: 'Show repeat notifications',
    showInDashboard: 'Dashboard',
    showInDashboardFilter: 'Only dashboard',
    times: 'razy',
    viewConnectedContact: 'View connected contact',
    youHaveUpcomingEvents: 'You have upcoming events'
  },
  order: {
    addAdditionalInfoInternal: 'Add additional internal comments to your offer',
    addDataOnInvoice: 'Add invoice details',
    addIndentOfferServicesDescription: 'Paste here additional description...',
    additionalDispatchCost: 'Additional shipping charges',
    additionalInfo: 'Additional information',
    additionalInfoInternal: 'Additional notes (internal)',
    additionalShippingCost: 'Additional shipping costs',
    additionalShippingCostAfterDiscount: 'Additional shipping costs after discount',
    addNewContactPerson: 'Add a new contact person',
    addNewFemenine: 'Add new',
    addNewInquiry: 'Add new inquiry',
    addNewOffer: 'Add new offer',
    addNewOrder: 'Add a new order',
    addNewOrderIndent: 'Add a new Indent order',
    addNewShippingAddress: 'Add new shipping address',
    addOffer: 'Add offer',
    addressIsRequiredForInvoice: 'Shipping address is required',
    addressIsRequiredForInvoiceDesc: 'Before sending invoice request, please specify the shipping address and save the order.',
    addressOfCorrespondence: 'Address for correspondence',
    addressRemoved: 'Previously used address has been removed. Please select new one.',
    advance: 'Advance',
    advanceNotPaid: 'Advance payment NOT paid',
    advancePaid: 'Advance paid',
    amountOfAdvance: 'Amount of the advance',
    assingedWorker: 'Assigned employee',
    attachmentForWarehouseman: 'Annex for the warehouse worker',
    attentionPriorityOrder: 'Attention! This order is prioritized',
    awaitingInvoice: 'waiting for an invoice',
    awaitingProductionComplete: 'awaiting completion of production',
    awaitingSample: 'awaiting sample',
    awaitingSampleAcceptance: 'awaiting sample approval',
    badPayerRequiresAdvance: 'Weak customer (requires advance payment)',
    basePricePerCarton: 'Base price per carton',
    beeingCollected: 'In the process of collecting',
    billingInvoice: 'Billing invoice',
    blockade: 'Blockade',
    blocked: 'Blocked',
    blockedOrderDifferentUser: 'This order is blocked, because is edited by different user ({user}).',
    blockedOrderSameUser: 'This order is blocked, because is edited by you in different browser tab.',
    blockedQuestionMark: 'Blockade?',
    blockErpInvoiceRequest: 'Block invoice requests in ERP Optima',
    boxCommentsPopup: {
      createdAt: 'Added',
      description: 'Comment',
      noComments: 'No comments for this product',
      operation: 'Operation',
      operationCollection: 'Collection',
      operationReturn: 'Return',
      operationVerification: 'Verification',
      title: 'Comments from the collection and verification of the product'
    },
    boxMarkingNumber: 'BOX MARKING number',
    brand: {
      brand: 'Brand',
      enterBrand: 'Enter a brand',
      noBrandsMatchingPhrase: 'No brands matching the given phrase'
    },
    canChangeAdvanceToNormalPayment: 'Attention!',
    canChangeAdvanceToNormalPaymentDesc: 'This customer has already paid several proformas. After consulting with the administration, it is possible to waive the deposit.',
    cannotBeVirtual: 'This order cannot be virtual',
    cannotBeVirtualDesc: 'Products in this order contains reservations in supplier orders or in containers.',
    cannotBeVirtualDescSync: 'This order is synced',
    cannotPlaceOrderWithUnavailableProductsChangeAndTryAgain: 'You cannot add an order that has unavailable products. Modify your order and try again.',
    cartonsNumber: 'Number of cartons',
    changed: 'Changed orders',
    changeOrderStatus: 'Change order status',
    checkCartonsAmount: 'Warning - suggested cartons number is different than configured - please make sure that cartons number is correctly configured.',
    chooseShippingAddress: 'Select shipping address',
    clientContactPerson: 'Customer contact persona',
    cod: 'Cash on delivery',
    collectedAgain: 'Collected again',
    collectedProductsCountDifferentThanOrdered: 'The number of products collected differs from the quantities ordered.',
    commentsForCustomer: 'Notes from the customer',
    commentsForWarehouseman: 'Notes for the warehouseman',
    commentsFromWarehouse: 'Notes from the warehouse',
    commentsRegardingOrder: 'Comments on the order',
    commentsSaved: 'Comments were saved',
    commentsToOrder: 'Comments on the order',
    confirmationsPopup: {
      confirmationText: 'Informations to confirm',
      iConfirm: 'I confirm - continue save process',
      notAllConfirmedText: 'Review all the informations and confirm it to continue.',
      notAllConfirmedTitle: 'You must confirm all informations',
      title: 'This order requires verification before save - review the informations below - confirm them to continue save process'
    },
    confirmOrder: 'Approve order',
    confirmOrderDisabled: 'Order confirmation is disabled',
    connected: {
      addRelatedOrders: 'Add related orders',
      addRelation: 'Add binding',
      noOrdersToAssociate: 'No orders to associate',
      selectRelatedOrder: 'Select related order'
    },
    connectedInvoices: 'Related invoices',
    connectedOrders: 'Related orders',
    createdFromOfferInquiry: 'Created from an inquiry',
    createInvoiceOrChangeToSent: 'ISSUE A VAT INVOICE OR CHANGE THE ORDER STATUS TO SHIPPED IF YOU ARE WAITING FOR SOMETHING',
    creationDate: 'Creation date',
    customerAndName: 'Customer and name',
    customerCheck: {
      check: 'Verify data',
      desc: 'If not, click the button to verify the contractor’s details before issuing the invoice',
      ok: 'The details are correct',
      title: 'Have you made sure that the invoice details are correct?'
    },
    customerDiscountsDisabledDesc: 'Due manual change of price in one of the elements - customer discounts has been disabled.',
    customerDiscountsDisabledTitle: 'Customer discounts has been disabled',
    customerOrderDescription: 'Text order of customer',
    customerOrderNumber: 'Custom name of customer order',
    customerTags: 'Customer tags',
    customPrice: 'Custom price',
    customPricesResetDesc: 'In products and services there were custom prices which has been reset.',
    customPricesResetTitle: 'Custom prices reset',
    customTransactionType: 'Force transaction type',
    dashOrderAwaitingShipping: '- orders awaiting shipment',
    dashReadyForShipping: '- ready for shipping',
    dataOnInvoice: 'Invoice data',
    dateOfIssue: 'Date of issue',
    delayed: 'Delayed',
    delayedSamples: 'Delayed samples',
    deleted: 'Removed',
    deletedStatusCannotBeChanged: 'This status cannot be changed. Are you sure that you want to change the order status?',
    delivery: 'Delivery',
    deliveryNote: 'Delivery note',
    deliveryNotesFileNamePrefix: 'document-delivery-order-no-',
    differentsPopup: {
      boxesQty: 'In boxes',
      orderQty: 'In order',
      productName: 'Product name',
      title: 'Founded differences in order and boxes'
    },
    dispatchCost: 'Shipping cost',
    download: 'Download',
    downloadOrderAttachment: 'Download an attachment to the order',
    downloadOrderMarkingDoc: 'Download a marking doc to the order',
    downloadOrderSummary: 'Download order summary',
    downloadProforma: 'Download proforma invoice',
    downloadStock: 'Download products stock',
    downloadXls: 'Download XLS',
    doYouReallyWantToChangeOrderSatus: 'Are you sure you want to change your order status?',
    doYouWantToUpdatePrices: 'Are you sure you want to update prices?',
    doYouWantToUpdatePricesDesc: 'All product and service prices will be updated according to the current pricing tables.',
    duplicatePopup: {
      copyFiles: 'Duplicate with files',
      duplicateOrder: 'Duplicate order',
      text: 'Do you want to duplicate this order with order attached files? <br><br><span style="color:red;">PLEASE CHECK IF PRICE UPDATE IS NECESSARY</span>',
      title: 'Duplicating order'
    },
    editInProgressBy: 'Edited by {user}',
    ended: 'Completed',
    enterOrderNumber: 'Enter order number',
    erp: {
      excludeFailedDesc: 'This order is excluded from ERP integration',
      excludeFailedTitle: 'Excluded from ERP integration',
      excludeFrom: 'Exclude from ERP integration',
      includeFailedDesc: 'This order is included to ERP integration',
      includeFailedTitle: 'Included to ERP integration',
      includeTo: 'Include to ERP integration',
      integratedWithErp: 'Integrated with ERP',
      isErpSynchronised: 'Integrated with ERP?',
      isExcluded: 'Is excluded from ERP integration',
      latestQuery: 'Last ERP integration status',
      latestQueryStatus: {
        DONE: 'Integrated',
        ERROR: 'Error',
        QUEUED: 'Waiting',
        WAITING: 'Waiting'
      },
      notIntegratedWithErp: 'Not integrated with ERP',
      popup: {
        action: 'Action',
        actions: {
          ADD_ORDER: 'Order add',
          DELETE_ORDER: 'Order deletion',
          DELETE_PURCHASE: 'Purchase deletion',
          GENERATE_GNR_FOR_PURCHASE: 'PZ generation',
          GENERATE_INVOICE: 'Invoice generation',
          INSERT_PURCHASE: 'Purchase add',
          SEND_ORDER: 'Order send',
          UPDATE_ORDER: 'Order update',
          UPDATE_PURCHASE: 'Purchase update'
        },
        errorMessage: 'Error message',
        queryStartedAt: 'Query date',
        status: 'Status',
        title: 'ERP integration history'
      }
    },
    errorDuringLoadingShippingPrice: 'An error occurred during loading shipping price. Please verify the shipping price.',
    errors: {
      block_erp_invoice_request: 'For this order an advance invoice has been issued. Please issue final invoice from ERP Optima.',
      container_not_closed: 'Container has not been closed',
      empty_prices: 'Fill all prices before sending invoice',
      empty_receiver_email: 'Missing invoice receiver e-mail',
      empty_tracking_number: 'Missing tracking number',
      exclude_from_erp_integration: 'This order is excluded from ERP integration',
      invalid_address_country_prefix: 'Invalid country prefix in the delivery address',
      invalid_invoice_country_prefix: 'Invalid country prefix in the invoice data',
      invalid_status: 'Invalid order status',
      invoice_exists: 'Invoice for this order exists',
      invoice_request: 'Invoice request has been already sent',
      not_synchronized: 'The order is not synced yet with Softlab',
      purchase_not_closed: 'Purchase from shipper has not been closed',
      shipping_price_not_fetched: 'An error occurred during updating shipping price. Please verify shipping price.'
    },
    estimatedShippmentDate: 'Estimated date of shipment',
    evidence: 'History of changes',
    evidenceInfoAvailableAfterSave: 'History of changes will be available after saving the order',
    evidencePopup: {
      amount: 'Amount',
      price: 'Price',
      productName: 'Product name',
      serviceName: 'Service name',
      title: 'State of order from '
    },
    excludeInInvoice: 'Do not send to ERP',
    executionDate: 'Completion deadline',
    executionTime: 'Delivery time',
    exisitngProductsInHplOrder: 'There are related products in the HPL order',
    files: {
      addFile: 'Add file(s)',
      addFiles: 'Add files',
      addingFile: 'Adding file',
      cancelAddingFile: 'Cancel adding file',
      cannotAddFiles: 'Files can be added only to orders which are saved. Please save this order to add files.',
      cannotAddServiceFiles: 'Files can be added only to services which are saved. Please save this order to add files.',
      deleteFile: 'Delete file',
      editFile: 'Edit file',
      editFileText: 'Please provide updated description for the file',
      editFileTitle: 'Change file description',
      fileEditedTitle: 'File has been edited',
      fileEditError: 'An error occurred during file edit. Please try again.',
      fileName: 'File description',
      fileNameCannotBeEmpty: 'File description cannot be empty',
      noFilesToDisplay: 'No files for this order',
      noServiceFilesToDisplay: 'No files for this service',
      removeFileDesc: 'This operation cannot be undone',
      removeFileTitle: 'Do you really want to remove this file?',
      selectFileToUpload: 'Please select file(s) to add',
      title: 'Files added to this order',
      uploadError: 'An error occurred during adding file'
    },
    forAcceptance: 'For approval',
    forceInvoiceRequestAnyway: 'Request invoice anyway',
    forFree: 'Product for free',
    foundDifferencesInCollectedProductsQuantity: 'Differences in quantities of products collected were detected',
    freeDelivery: 'Free shipping',
    gusComparision: {
      dataFromGus: 'GUS',
      dataFromOrder: 'Order',
      dataInCustomer: 'Current customer data in system',
      dataOkContinue: 'Data correct, continue',
      rowTitle: {
        city: 'City',
        houseNumber: 'House number',
        name: 'Name',
        postCode: 'Postal code',
        street: 'Street',
        streetNumber: 'Street number',
        taxNumber: 'TAX ID'
      },
      title: 'Comparision of invoice data in order and GUS',
      titleNoComparision: 'Current customer\'s invoice data',
      update: 'Update data in customer and order',
      updateOnlyCustomer: 'Update data in customer'
    },
    hafciarnia: {
      dateOfTransferToHafciarnia: 'Date of transfer to Hafciarnia',
      embrioderyLogs: {
        action: 'Action',
        actionType: {
          add_sample: 'Add sample',
          add_status: 'Add status',
          synchronize: 'Order sync',
          synchronize_embroidery_return: 'Registration of product returns from the Hafciarnia',
          synchronize_files: 'Files sync',
          synchronize_production_ended: 'Production ended date sync'
        },
        createdAt: 'Log creation date',
        source: 'Source',
        sourceType: {
          order: 'Order',
          product: 'Product',
          service: 'Service'
        },
        status: 'Status'
      },
      embroideryReturns: {
        createdAt: 'Return creation date',
        products: 'Returned products',
        status: 'Return status',
        statuses: {
          receivedInHPL: 'Return received in HPL',
          returned: 'Returned from Hafciarnia',
          toReturn: 'Preparing the return in Hafciarnia'
        }
      },
      hafciarnia: 'Hafciarnia',
      listOfOordersInHafciarnia: 'List of orders in Hafciarnia',
      noHafciarniaIdInfo: 'No order ID in Hafciarnia - it is not possible to generate a reference to the order in Hafciarnia.',
      notSynced: 'Not synced',
      orderInHafciarnia: 'Order in Hafciarnia',
      ordersInHafciarnia: 'Orders in Hafciarnia',
      sendAgainToEmbroidery: 'Send again to embroidery',
      sendingAgainToEmbroideryDesc: 'The order has been sent again to embroidery',
      sendingAgainToEmbroideryTitle: 'Sent again to embroidery',
      sendToHafciarnia: 'Send to Hafciarnia',
      sendToHafciarniaErrorText: 'An error occurred while sending order to Hafciarnia. Please try again.',
      sendToHafciarniaSuccessText: 'The order will be added in Hafciarnia in a few minutes.',
      sendToHafciarniaSuccessTitle: 'Order sent to Hafciarnia',
      syncDate: 'Sync date',
      synced: 'Synced',
      syncInProgress: 'Sync in progress'
    },
    hasIECommunicate: 'FINAL IE - YES',
    hasNoSaleProducts: 'Not contains sale products',
    hasNoSpecialRequirement: 'No special requirements',
    hasNotIECommunicate: 'FINAL IE - NO',
    hasSaleProducts: 'Yes, contains sale products',
    hasSaleProductsQuestion: 'Contains sale products?',
    hasSpecialRequirement: 'With special requirements',
    hasSpecialRequirementMark: 'Special requirements?',
    hasSpecialRequirementsWarning: 'Attention! This order has special requirements',
    hasSpecialRequirementsWarningPopupDesc: 'CUSTOMER HAS SPECIAL REQUIREMENTS SET - PLEASE CHECK',
    hasSpecialRequirementsWarningPopupTitle: 'ATTENTION!',
    history: 'History',
    iAcceptOrder: 'I take the order',
    ieCommunicate: 'Export communicate FINAL IE',
    iefiles: {
      addFile: 'Add file(s)',
      addFiles: 'Add files',
      addingFileFinal: 'Add files for "Final Communication"',
      addingFileInitial: 'Add files for "Initial Communication"',
      cancelAddingFile: 'Cancel adding file',
      cannotAddFiles: 'Files can only be added to saved orders. Save the order to add files.',
      cannotRemoveLastInitialFile: 'If any "Final communication" file exists, you must have at least one "Initial communication" file. Remove all "Final communication" files to remove all "Initial communication" files.',
      deleteFile: 'Delete file',
      noFilesToDisplay: 'No files associated with this order',
      removeFileDesc: 'This operation cannot be undone',
      removeFileTitle: 'Are you sure you want to delete this file?',
      selectFileToUpload: 'Select file(s) to upload',
      title: 'IE599 Export Communication Files',
      uploadError: 'An error occurred while uploading the file'
    },
    indent: {
      selectWarehouse: 'Select warehouse',
      warehouse: 'Proper warehouse'
    },
    indentOffers: 'Oferty Indent',
    indentOfferServicesDescription: 'Additional description for indent services',
    inProduction: 'In production',
    inquiryName: 'Name of inquiry',
    inquirySubmissionDate: 'Date of the inquiry',
    invalidGlobalServicesSums: 'Incorrectly divided global services',
    invalidGlobalServicesSumsIntro: 'The below global services have too less or too much assigned products:',
    invalidShippingCostDesc: 'Invalid order configuration: shipping cost is 0, and free delivery is disabled.',
    invalidShippingCostTitle: 'Invalid shipping cost',
    invoice: {
      advanceInvoiceAmount: 'Advance invoice amount',
      diffPopup: {
        invoice_building: 'Building number',
        invoice_city: 'City',
        invoice_country_prefix: 'Country code',
        invoice_locale: 'Premises number',
        invoice_name: 'Name on invoice',
        invoice_postcode: 'Postal code',
        invoice_street: 'Street',
        invoice_tax_number: 'NIP / VAT ID'
      },
      issueAnAdvanceInvoice: 'Issue a prepayment invoice'
    },
    invoiceCountryPrefixIsRequiredForInvoice: 'Missing customer data',
    invoiceCountryPrefixIsRequiredForInvoiceDesc: 'Selected customer does not have specified invoice country prefix. Please go to the customer edit form and fill the missing data. Then please go back to order and click button "Update customer invoice data"',
    invoiceCustomerValue: 'Current customer value',
    invoiceDataUpdated: 'Data updated',
    invoiceDataUpdatedDesc: 'Customer invoice data has been updated.',
    invoiceDiffPopupDesc: 'Verify if order invoice data are correct. If not - please close this popup and click the "Update customer invoice data" button.',
    invoiceDiffPopupTitle: 'Current customer invoice data are different than these saved in the order',
    invoiceField: 'Value name',
    invoiceOrderValue: 'Value stored in order',
    invoicePdf: 'Invoice (PDF)',
    invoiceRequestCancel: 'Cancel invoice<br> request',
    invoiceRequestCancelError: 'An error occurred during cancelling invoice request',
    invoiceRequestCancelText: 'Invoice request has been cancelled',
    invoiceRequestCancelTitle: 'Invoice request cancelled',
    invoiceRequestSent: 'Invoice request sent',
    invoiceRequestSentText: 'Invoice request sent',
    invoiceRequestStatusQuestionMark: 'Invoice request sent?',
    invoicesInfoAvailableWhenOfferIsInquiry: 'Invoice data will be available when the offer becomes an order',
    invoicesIssued: 'Invoices issued',
    invoiceZip: 'Invoice (ZIP)',
    isBoxMarking: 'BOX MARKING',
    isContractor: 'Contractor?',
    isDelayed: 'Delayed?',
    isDelayedSample: 'Delayed samples?',
    isPriority: 'Priority?',
    isRepeated: 'Repeated order',
    isSpecialRequirement: 'Special requirements',
    issueAnInvoice: 'Issue an invoice',
    isVirtual: 'Virtual order',
    isWorker: 'Employee?',
    itemDuplicateError: 'An error occurred while duplicating',
    itemDuplicateSuccess: 'The selected item was duplicated',
    lastChange: 'last change',
    lastItemModified: 'Last modified',
    lastItemViewed: 'Last viewed',
    lastSendReminderDate: 'Last reminder sent',
    leaveWithoutSave: 'Leave without saving',
    loadHistoryOfChanges: 'Load history of changes',
    lock: {
      configureOrderLock: 'Configure order lock',
      dateOfBlocking: 'Date of blocking',
      dateOfProductsReturn: 'Date of returning the products',
      noLock: 'No lock',
      orderLock: 'Order lock',
      returnPrductWarningInfo: 'Once the products are returned, the order status will change to \"To collect\".',
      unBlock: 'Remove lock',
      warehousemanReturningProducts: 'Warehouseman returning products'
    },
    lockOrder: 'Block edit',
    lockSuccessText: 'The order edit possibility has been locked',
    lockSuccessTitle: 'Order edit locked',
    markingFileNamePrefix: 'indication-order-number-',
    modificationDate: 'Modification date',
    moq: 'MOQ',
    nameCheck: {
      inProgress: 'Checking order name',
      inUse: 'Selected order name is in use by other orders.',
      inUseCTA: 'See these orders ({count})',
      isAvailable: 'Selected order name is available',
      popup: {
        id: 'ID',
        lastModified: 'Last modified',
        name: 'Name',
        status: 'Status',
        title: 'Orders with the same name'
      }
    },
    newOffer: 'New offer',
    newOrdersQuestionMark: 'New orders?',
    noAddresses: 'No addresses',
    noAddressesForThisClient: 'No addresses assigned to the customer.',
    noAddressFound: 'Selected address not found',
    noAdvanceInfo: 'No down payment, dont\'t send merchandise, dont\'t issue an invoice',
    noConnectedOrders: 'No related orders',
    noContactPeople: 'No contact persons',
    noContactPeopleAssignedToClient: 'No persons assigned to the customer.',
    noFile: 'No file',
    noInvoice: 'No invoice',
    noInvoicesConnectedToOrder: 'No invoices related to this order',
    nonExistingCustomerText: 'The customer assigned to this order has been deleted. Please assign a customer to the order again.',
    nonExistingCustomerTitle: 'The selected customer does not exist',
    noOfferInquriesToDisplay: 'No inquiries to display',
    noOffersOrOrdersToDisplay: 'No offers or orders to display',
    noOrderMatchingPhraseFound: 'No orders matching the given phrase',
    noPriority: 'No priority',
    noProductsOrServicesIn: 'No products or services in',
    noRemindersSent: 'No submitted reminders',
    noSettlementsText: 'Setting the status to Completed will end the integration with the ERP. Are you sure you want to change the order status?',
    noSettlementsTitle: 'No invoices issued',
    noTagsMatchingGivenPhrase: 'No features that match the given phrase',
    notAllProductsHaveItemsInCartonInfoWarning: 'Not all products in the order have information on the number of pieces per carton - the number of cartons needed may be higher than recommended.',
    notChanged: 'Not changed orders',
    notDelayedSamples: 'Without delayed samples',
    notRepeated: 'Without repeated orders',
    number: 'Number',
    numberOfOrderdItems: 'Number of pieces ordered',
    numberOfOrderdProducts: 'Number of products ordered',
    numberOfOrderdServices: 'Number of services ordered',
    offerAccusative: 'offer',
    offerClosed: 'Outdated offer',
    offerFileNamePrefix: 'offer-no-',
    offerInquiriessList: 'List of inquiries',
    offerLanguage: 'Language of the offer',
    offerLoading: 'Loading offer in progress',
    offers: 'Offers',
    offersAndOrders: 'Offers and Orders',
    offersList: 'List of offers',
    offersListIndent: 'List of Indent offers',
    offersToCheck: 'Offers to check',
    offerSubmissionDate: 'Date of submitting the offer',
    offerSummaryFileNamePrefix: 'summary-offer-no-',
    okIUnderstand: 'Ok, I understand',
    optionInvoiceRequestNotSent: 'Invoice request not sent',
    optionInvoiceRequestSent: 'Invoice request sent',
    orderAccusative: 'order',
    orderAssignedTo: 'Order assigned to',
    orderChangedStatus: 'Order changed',
    orderCollectedPartiallyOutOfStock: 'Partially collected order - out of stock.',
    orderCollectErrorText: 'Order acceptance failed. Please try again.',
    orderContainsUnavailableProducts: 'Order contains unavailable products',
    orderCostNet: 'Order cost (net)',
    orderCurrency: 'Currency of the order',
    orderDative: 'order',
    orderDativeCap: 'Order',
    orderDeleteConfirmTitle: 'Are you sure you want to delete this order?',
    orderDeleteErrorText: 'Order deletion failed. Please try again.',
    orderDeleteSuccessText: 'The selected order has been deleted',
    orderDeleteSuccessTitle: 'Order deleted',
    orderFileNamePrefix: 'order-no-',
    orderFromSupplier: 'Order from a supplier',
    orderLoadingErrorTryAgain: 'An error occurred while loading your order data. Please try again',
    orderNotExistsDesc: 'An error occurred during loading this order. Probably it does not exist or has been removed.',
    orderNotExistsTitle: 'Cannot load selected order',
    orderNumber: 'Order number',
    orderPlacedByClientMissingInfo: 'Order placed by Customer. No data filled in.',
    orderPreview: 'Order preview',
    orderProformaFileNamePrefix: 'proforma-invoice-',
    orderPurchaseProductsConfirmErrorText: 'System is unable to confirm product receive. Please try again',
    orders: 'Orders',
    ordersCollectedPartially: 'Order collected partially',
    ordersIndent: 'Indent Orders',
    ordersList: 'List of orders',
    ordersListIndent: 'List of Indent orders',
    orderStatus: 'Order status',
    orderSubmissionDate: 'Date of submitting the order',
    orderSummaryFileNamePrefix: 'summary-order-no-',
    ordersXlsFilename: 'orders-list',
    orderTags: 'Order tags',
    orderWontBeSentToErpDueLackOfVerifiedVIES: 'This order will not be submitted to ERP due to lack of VAT number verification in VIES.',
    paymentDate: 'Payment date',
    paymentDeadline: 'Payment deadline',
    pendingPayment: 'Awaiting payment',
    pendingProductsFromSupplier: 'Awaiting products from supplier',
    postCodeCheckFailed: 'Postal code verification failed',
    preferedByClientExecutionDate: 'Customer\'s preferred delivery date',
    prepaidInvoice: 'Advance payment invoice',
    priceChangePopup: {
      applied: 'Applied',
      globalServiceName: 'Service name',
      globalServicesTitle: 'Common services',
      multiplierChange: 'Multiplier change',
      notApplied: 'Skipped',
      priceChange: 'Price change',
      priceSetupChange: 'Setup price change',
      productName: 'Product name',
      productsTitle: 'Products',
      serviceName: 'Service name',
      servicesTitle: 'Services in products',
      status: 'Status',
      title: 'List of the applied price changes'
    },
    priority: 'Priority',
    priorityCap: 'PRIORITY',
    priorityOrder: 'PRIORITY order',
    problemWithInvoice: 'Problem with an invoice',
    productMinQty: 'Min. quantity',
    productsTags: 'Product features',
    puesc: {
      canChangeOrderWeight: 'The order weight can be changed while submitting the SENT_100 request to PUESC',
      carrierKey: 'Carrier authorization key',
      createdAt: 'Creation date',
      integrationNotAvailable: 'Integration with PUESC is not available for this order',
      keys: 'Keys',
      message: 'Additional information',
      noItemsToDisplay: 'No items to display...',
      orderChangeDetected: 'Changes in the order products have been detected – save the order before adding the SENT_100 request to PUESC to get the updated order weight',
      orderWeight: 'Order weight',
      recipientKey: 'Recipient authorization key',
      senderKey: 'Sender authorization key',
      sent100popup: {
        addRequest: 'Add request',
        addRequestSuccessText: 'The SENT_100 request to PUESC has been sent',
        addRequestSuccessTitle: 'Request added',
        carriageDate: 'Planned shipment date',
        city: 'City',
        countryCode: 'Country code',
        flatNumber: 'Apartment number',
        houseNumber: 'Building number',
        loadingSection: 'Loading address details',
        name: 'Recipient name',
        postCode: 'Postal code',
        recipientSection: 'Recipient details',
        street: 'Street',
        taxNumber: 'Customer NIP / VAT ID',
        title: 'Add SENT_100 request to PUESC',
        weight: 'Shipment weight'
      },
      sentNumber: 'SENT number',
      status: 'Status',
      statuses: {
        ADD_TO_PUESC: 'Waiting for add',
        ERROR: 'Error',
        PUESC_INTEGRATED: 'Submitted, waiting for PUESC accept',
        PUESC_SUCCESS: 'Reported to PUESC'
      },
      submitSent100: 'Add SENT_100 request to PUESC',
      title: 'PUESC'
    },
    purchaseInfoInvoiceAdded: 'Invoice added to system',
    purchaseInfoInvoiceFile: 'Invoice issued',
    purchaseInfoStatus: 'Purchase status:',
    readyForShipping: 'Ready to ship',
    reallyWantToUpdateCustomerInvoiceData: 'Do you want update data?',
    reallyWantToUpdateCustomerInvoiceDataDesc: 'After this operation, customer invoice data will be updated with use of the newest customer data available in the system. The order will be reloaded. Unsaved changes will be lost.',
    recommendedCartonsNumber: 'Recommended number of cartons',
    reminderDate: 'Reminder submit date',
    reminderErrorTitle: 'An error occurred during sending reminder. Please try again.',
    reminderSentDesc: 'Reminder has been sent.',
    reminderSentTitle: 'Reminder sent!',
    remindersList: 'Submitted reminders',
    reminderType: 'Reminder type',
    reminderTypeDraft: 'Reminder about project',
    reminderTypeNewCustomerOrder: 'New customer order',
    reminderTypeNoSampleInIndent: 'No samples in indent',
    reminderTypeNoShipperDateInIndent: 'No shipper date in indent',
    reminderTypePodReminder: 'Products delivery reminder',
    reminderTypeSampleNotApprovedInIndent: 'Sample not approved in indent',
    reminderTypeWaitingAccept: 'Reminder about awaiting accept',
    reminderTypeWaitingProduction: 'Reminder about awaiting ending production',
    reminderTypeWaitingSample: 'Reminder about awaiting samples',
    reminderTypeWorkerReminder: 'Worker reminder',
    remindMeAfter: 'Stash and remind me later:',
    removeAllProductsConfirmText: 'All products and services from this offer will be removed.',
    removeAllProductsConfirmTitle: 'Are you sure you want to delete all products?',
    removeDate: 'Remove date',
    repeated: 'Repeated orders',
    repeatedOrdersQuestionMark: 'Repeated orders?',
    repeatNumber: 'Repeated order number(s)',
    requestForBillingInvoiceSentSuccessText: 'A request for a billing invoice has been sent',
    requestForInvoiceInAdvanceSentSuccessText: 'A request for an advance invoice has been sent',
    requestInvoice: 'Request invoice',
    requestSent: 'Request sent',
    requestSentErrorText: 'Sending request failed. Please try again.',
    requiresAdvance: 'Requires an advance payment',
    reservationsInContainersAndSuppliersCancelledAfterStatusChange: 'Bookings in containers and with suppliers will be cancelled when the status changes.',
    returnToStock: 'Return to stock',
    sampleRequirementDate: 'Sample requirement date',
    sampleRequirementDays: 'Sample requirement days',
    samplesNotRequired: 'No samples required',
    saveChangesBeforeLeaveDesc: 'Do you want to save changes before leaving this view?',
    saveChangesBeforeLeaveTitle: 'Do you want to save changes?',
    saveComments: 'Save your comments',
    saveDate: 'Date of save',
    saveOffer: 'Save offer',
    saveOrderWithNewCustomerToRequestInvoice: 'Save changes after changing customer - then you can request invoice',
    see: 'See',
    selectExecutionTime: 'Select lead time',
    selectNewStatus: 'Select new status',
    selectOrder: 'Select order',
    selectTransactionType: 'Select transaction type',
    selectWarehouseman: 'Select warehouseman',
    sendReminder: 'Submit reminder',
    sent: 'Sent',
    sentToCustomer: 'Sent to the customer',
    servicesGenitive: 'Services',
    servicesNotReceived: 'Decorations not received',
    servicesReceived: 'Decorations received',
    settlementNumber: 'Settlement number',
    shipment: 'Shipping',
    shipperAndAddressAreNecessaryToCalculatePrice: 'Shipper and shipping address are necessary to calculate the cost of freight',
    shippingAddress: 'Shipping address',
    shippingCost: 'Shipping cost',
    shippingCostAfterDiscount: 'Shipping cost after discount',
    shippingCostCustom: 'Dedicated shipping cost',
    shippingCostPreviousVersion: 'Shipping price before changes',
    showAddress: 'Show address',
    showAllOrders: 'Show all orders',
    showContact: 'Show contact',
    showOrders: 'Show orders',
    showOtherWorkersData: 'Show all workers data',
    softlabBlockadeStatus: 'SL blockade',
    softlabBlockadeStatusFull: 'full',
    softlabBlockadeStatusPartial: 'partial',
    someProductsInDelivery: 'Some products are in the process of delivery',
    someProductsLackAvailabilityInfoChangeAndTryAgain: 'Some of the selected products do not have availability information. Please modify your order and try again.',
    specialConfiguration: 'Additional configuration',
    specialRequirement: 'Describe special requirements...',
    specialRequirementSetText: 'Content of special requirements has been set according to settings of the currently selected customer',
    specialRequirementSetTitle: 'Special requirements set',
    statusHistory: 'Status history',
    summary: 'Summary',
    summeryPreview: 'Order preview',
    toCheckInWarehouse: 'To be checked in the warehouse',
    toCollect: 'To collect',
    toDelete: 'To be deleted',
    totalCost: 'Total cost',
    totalNet: 'Total (net)',
    trackingNumber: 'Tracking number',
    trackingNumberIsLocked: 'This field will be automatically updated, because new shipment connected with this order has been added.',
    transactionType: 'Transaction type',
    transactionTypeFieldUnlocked: 'Transaction type field is unlocked',
    transactionTypeFieldUnlockedDesc: 'Please verify if transaction type value is correct',
    transactionTypes: {
      domestic: 'Domestic',
      eu: 'UE',
      export: 'Export',
      noVatEU: 'No EU VAT'
    },
    transactionTypeSetToDomestic: 'Transaction type changed',
    transactionTypeSetToDomesticDesc: 'Due selected customer data, transaction type has been changed to "Domestic"',
    transactionTypeSetToDomesticDescSaveNeeded: 'This order according to previously selected customer data requires transaction type to be "Domestic". Please save this order to store transaction type set as "Domestic" for this order.',
    transactionTypeSetToExport: 'Transaction type changed',
    transactionTypeSetToExportDesc: 'Due selected address data, transaction type has been changed to "Export"',
    transactionTypeSetToExportDescSaveNeeded: 'This order according to previously selected address data requires transaction type to be "Export". Please save this order to store transaction type set as "Export" for this order.',
    transactionTypeSetToNoEuVAT: 'Transaction type changed',
    transactionTypeSetToNoEuVATDescSaveNeeded: 'This order according to previously selected address data requires transaction type to be "No EU VAT". Please save this order to store transaction type set as "No EU VAT" for this order.',
    unblockError: 'Unblock operation did not complete successfully. Please try again.',
    unblockOrder: 'Unblock',
    unblockOrderDesc: 'If order is edited by different user in the same time, it can be overridden by this user. Please make sure that you won\'t override order data changes made by other system users.',
    unblockOrderTitle: 'Unblock order?',
    unlockOrder: 'Unlock edit',
    unlockOrderNotice: 'This order is in read-only mode',
    unlockSuccessText: 'Edit of this order is unlocked. After closing this popup, website will refresh and you will be able to edit this order.',
    unlockSuccessTitle: 'Edit unlocked',
    updateCustomerInfoOnInvoice: 'Update customer invoice data',
    updatePricesUsingCurrentPricing: 'Update prices',
    useCustomPrice: 'Use custom price',
    useThisValue: 'Apply',
    waitingForShipping: 'Waiting for shipment',
    waitingPurchaseProducts: 'Awaiting products',
    warehouse: {
      addCommentsForWarehouse: 'Add notes for the magazine',
      attachDeliveryNote: 'Attach Delivery Note to the package',
      boxes: {
        acceptBoxes: 'Accept boxes partitioning',
        acceptDesc: 'After accepting boxes partitioning it cannot be edited.',
        acceptTitle: 'Do you want to accept partitioning?',
        addBox: 'Add box',
        addProduct: 'Add product',
        boxesWarning: 'Edit the division into boxes, correct all values and save the division again. After saving, confirm the division. Remember that if you add or remove a box, you need to regenerate the labels.',
        cancelBoxes: 'Edit boxes partitioning',
        cancelDesc: 'After making changes to the edited carton division, remember to save them again and accept the division into cartons.',
        cancelTitle: 'Do you want to edit partitioning?',
        changesHistory: 'Changes history',
        cheatsheet: {
          collected: 'Collected',
          divided: 'In boxes',
          fromSupplier: 'From supplier',
          includingSupplier: 'Including supplier',
          piecesInCarton: 'In box',
          productName: 'Product',
          realPiecesInCarton: 'Real in box',
          status: 'Current state of products partitioning',
          title: 'Amount of products in box',
          toDivide: 'To divide',
          verified: 'Verified'
        },
        clickToConfirmDeletion: 'Click again to remove',
        clickToConfirmReturnToStock: 'Click again to return to stock',
        collected: 'Collected',
        collectHistory: 'Collect history',
        deliveryNoteConfirmedAt: 'Confirmation of the attachment of a delivery note',
        deliveryNoteConfirmedBy: 'Confirmed by',
        downloadAllLabels: 'Download all labels',
        downloadLabel: 'Download label',
        fillLevel: 'Filled',
        generateBoxes: 'Generate proposition of boxes partitioning',
        hasDifferentInProducts: 'The order has been modified. The division into boxes needs to be adjusted.',
        inBox: 'In box',
        info: {
          boxesAlert: 'Attention! Differences were detected in the number of products in the cartons compared to the number of products needed',
          embroideryAlert: 'Attention! Comments have been reported for boxes received from the embroidery',
          embroideryComment: 'Comments from the person receiving the box from the embroidery',
          embroideryReceivedAt: 'Date of receiving the box from the embroidery',
          embroideryReceivedBy: 'Received from the embroidery by',
          embroiderySentAt: 'Date of sending the box to the embroidery',
          embroiderySentBy: 'Sent to the embroidery by',
          shipmentSentAt: 'Date of box shipment',
          shipmentSentBy: 'Shipped by'
        },
        notes: 'Notes',
        outOfStock: 'Out of stock',
        popup: {
          status: {
            logs: {
              COLLECT: 'Added collection',
              RETURN: 'Added return',
              SCAN: 'QR code label scan',
              VERIFY: 'Added verification'
            },
            statuses: {
              COLLECTION_COMPLETED: 'Collection completed',
              COLLECTION_IN_PROGRESS: 'Collection in progress',
              PREPARE_LABEL: 'Label preparation',
              RETURN_COMPLETED: 'Return completed',
              RETURN_IN_PROGRESS: 'Return in progress',
              TO_COLLECT: 'To collect',
              TO_RETURN: 'To return',
              TO_VERIFY: 'Waits to verify',
              VERIFICATION_COMPLETED: 'Verification completed',
              VERIFYING_IN_PROGRESS: 'Verification in progress'
            }
          },
          table: {
            createdAt: 'Event date',
            notes: 'Notes',
            quantity: 'Collected',
            returned: 'Returned',
            status: 'Status',
            type: 'Action type',
            user: 'User',
            verified: 'Verified'
          },
          title: {
            collections: 'Product collect history',
            logs: 'Box operations history',
            returns: 'Box returns history',
            statuses: 'Box statuses history',
            verifications: 'Box product verification history'
          }
        },
        productNotExistsInOrder: 'This product no longer appears in the order',
        productQtyError1: 'More have been collected than planned in boxes',
        productQtyError2: 'Too few products have been allocated in boxes',
        productQtyError3: 'Too many products have been allocated in boxes',
        productQtyError4: 'The quantity collected in boxes does not match the quantity summarized',
        productQtyError5: 'The quantity of products from supplier is bigger than quantity in boxes',
        productsAreNotDividedIntoBoxesYet: 'Products are not divided into boxes...',
        productsOver250Desc: 'Too many products in the box',
        productsOver250Title: 'A single box cannot contain more than 250 products',
        productsTooMuchDesc: 'The number of products in boxes is greater than the number of products in the order',
        productsTooMuchTitle: 'Too many products in boxes',
        removeBox: 'Remove box',
        removeBoxProductSuccessDesc: 'Product has been removed from the box',
        removeBoxProductSuccessTitle: 'Product removed',
        resetBoxes: 'Reset boxes',
        resetText: 'Current partitioning for boxes will be removed and generated from scratch.',
        resetTitle: 'Do you want to reset partitioning?',
        returned: 'Returned',
        returnedToStockAt: 'Product returned to stock',
        returnedToStockBy: 'by',
        returnHistory: 'Return history',
        returnInProgress: 'Return in progress',
        saveBoxes: 'Save and accept boxes partitioning',
        saveSuccessDesc: 'Boxes partitioning successfully saved',
        saveSuccessTitle: 'Partitioning saved',
        seeDetails: 'See details',
        status: {
          boxesCollected: 'Boxes collected',
          boxesCollectedBy: 'Collected by',
          boxesCollectedToday: 'Boxes collected today',
          boxesReturned: 'Boxes returned',
          boxesReturnedBy: 'Boxes returned by',
          boxesReturnedToday: 'Boxes returned today',
          boxesVerificationStatus: 'Verification status',
          boxesVerified: 'Boxes verified',
          boxesVerifiedBy: 'Verified by',
          boxesVerifiedToday: 'Boxes verified today',
          full: 'Fully verified',
          partial: 'Partialy verified',
          title: 'Boxes status'
        },
        statusHistory: 'Status history',
        title: 'Boxes partitioning',
        verificationHistory: 'Verification history',
        verified: 'Verified',
        yesReset: 'Yes, reset'
      },
      collectedAll: 'Collected in full',
      collectedPartially: 'Partially collected',
      collectedPartiallyOutOfStock: 'Partially collected, out of stock',
      commentsForWarehouse: 'Notes for the warehouse',
      deliveryDocument: 'Delivery document',
      deliveryNote: 'Delivery note',
      enteredValueIsGeaterThanCurrentStock: 'The entered value is greater <br>than the current stock ({valueStock} pcs.) <br>or than necessary amount ({valueQty} pcs.)',
      iChecked: 'Checked',
      IHaveReceivedOrderFromSupplier: 'I have accepted the order from a supplier',
      incorrectQuantity: 'Incorrect quantity',
      mark: 'Marking',
      notCollected: 'Not collected',
      notReturned: 'Not returned',
      orderBlockedAtCustomerRequest: 'This order is blocked at the request of the customer',
      orderCancelledReturnToStock: 'Order CANCELLED - return to stock',
      orderCollectingAgain: 'This order is collected again.',
      orderIsAlreadyBeeingCollectedByDifferentPerson: 'This order is already being completed by another person.',
      purchases: {
        orderName: 'Name',
        received: 'Received',
        receivedFromSubSupplier: 'I have received products',
        receivedFromSupplier: 'I have received products',
        title: 'Related orders from suppliers'
      },
      receiveFromSupplierErrorText: 'Order acceptance from a supplier has failed. Please try again.',
      receiveFromSupplierSuccessText: 'The order from the supplier was marked as accepted',
      receiveFromSupplierSuccessTitle: 'Order accepted',
      returned: 'Returned',
      returnedPartially: 'Partially returned',
      returnedWhole: 'Returned in full',
      returnToStock: 'Return to stock',
      submitCollectedSuccessText: 'The given order has been marked as collected in full.',
      submitCollectedSuccessTitle: 'Marked as collected',
      submitErrorText: 'Saving changes has failed. Please try again.',
      submitPartialSuccessText: 'The specified order has been marked as partially collected.',
      submitPartialSuccessTitle: 'Marked as partly collected',
      submitPartialWithEmptyStorageSuccessText: 'The specified order has been marked as partially collected.',
      submitPartialWithEmptyStorageSuccessTitle: 'Marked as partially collected',
      submitReturnSuccessText: 'The specified order has been marked for deletion.',
      submitReturnSuccessTitle: 'Products returned to stock',
      submitWaitingForProductsSccessTitle: 'Marked as pending products',
      submitWaitingForProductsSuccessText: 'The specified order has been marked as awaiting products from the supplier.',
      toStartCollectingOrderAcceptOrder: 'To start completing this order, take this order',
      toStartHandlingOrderReturnAcceptOrder: 'To start processing the return of this order, accept the order',
      waitingForMerchandiseFromSupplier: 'Waiting for merchandise from supplier',
      warehouseAvailability: 'Stock'
    },
    warehouseNewOrders: 'Only new orders',
    warehouseNotNewOrders: 'Without new orders',
    warehouseNotRepeatedOrders: 'Without repeated orders',
    warehouseRepeatedOrders: 'Only repeated orders',
    weakPayerWarning: 'Attention! The customer is a poor payer.',
    withDeadlineApproaching: 'which are approaching a deadline',
    yesSave: 'Yes, save changes',
    yesUnblock: 'Yes, unblock',
    yesUpdate: 'Yes, update data'
  },
  potentialCustomers: {
    activityStartAt: 'Add date',
    addNewContact: 'Add new contact with potential customer',
    addNewPotentialCustomerContact: 'Add new',
    address: 'Address data',
    contacts: 'Contacts with potential customer',
    createCustomerFromPotentialCustomer: 'Change to customer',
    dataLoadedCorrectlyDesc: 'Some fields has been set based on selected potential customer',
    dataLoadedCorrectlyTitle: 'Potential customer data loaded',
    deleteConfirmTitle: 'Do you really want to remove the potential customer?',
    deleteErrorText: 'An error occurred during potential customer removal. Please try again.',
    deleteSuccessText: 'The selected potential customer has been removed',
    deleteSuccessTitle: 'Potential customer has been removed',
    description: 'Contact description',
    errorLoadingData: 'An error occurred during loading potential customer data',
    exportFilename: 'potential-customers',
    noPotentialCustomersToDisplay: 'No potential customers to display',
    otherData: 'Other data',
    potentialCustomersLabel: 'Potential customers',
    potentialCustomersList: 'List of potential customers',
    potentialCustomersSearchPlaceholder: 'Enter name',
    potentialCustomerView: 'Potential customer',
    taxNumber: 'Tax number'
  },
  price: {
    addNewPrice: 'Add a new price',
    addNewProductPrice: 'Add a new product price',
    addNewServicePrice: 'Add a new service price',
    addNewSetupPrice: 'Add a new setup price',
    addPrice: 'Add price',
    addPriceErrorText: 'Adding a price has failed. Please try again.',
    addPriceSuccessText: 'The price has been saved',
    addPriceSuccessTitle: 'Price added',
    bruttonPrice: 'Gross price',
    chosenPriceIsSetupPrice: 'The given price is the price per setup',
    deletePriceConfirmTitle: 'Are you sure you want to delete this price?',
    deletePriceErrorText: 'Price removal failed. Please try again.',
    deletePriceSuccessText: 'The selected price has been deleted',
    deletePriceSuccessTitle: 'Price deleted',
    differentPriceMultipleFromInfo: 'The applied price multiplier "per unit from" is different from the current price multiplier ({value} pcs.)',
    editPrice: 'Edit the price',
    export: 'Export',
    exportPrices: 'Export price lists',
    exportSuccessfull: 'Price lists exported',
    exportSuccessfullDesc: 'Price lists exported successfully',
    importPrices: 'Import price lists',
    importSuccessfull: 'Price lists imported',
    importSuccessfullDesc: 'Price lists imported successfully',
    includeSetupPrices: 'Include setup prices',
    isSale: 'Sale',
    noPricesFoundForServiceGroup: 'Price lists for the selected group of services were not found',
    noPricesToDisplay: 'No prices to display',
    onlyChildren: 'Only variants',
    onlyPriceUpdate: 'Price update only',
    pln: 'PLN',
    plnBrutto: 'PLN gross',
    plnNet: 'PLN net',
    plnVat: 'PLN VAT',
    price: 'Price',
    price25pcs: 'to 25 pcs.',
    priceBeforeDicount: 'Price before discount',
    priceBox: 'Quantity-based price',
    priceEdit: 'Price edit',
    priceFirstBox: 'First box',
    priceFlat: 'Flat price',
    priceFrom: 'Price from',
    priceImportFrom: 'Prices imported from',
    priceNet: 'Net price',
    priceNextBox: 'Next box',
    pricePerItem: 'Price per piece',
    pricePerItemFrom: 'Price per piece from {price} pcs.',
    pricePerItemShort: 'Price per piece',
    prices: 'Prices',
    priceSecondBox: 'Second box',
    pricesList: 'Price list',
    pricesLists: 'Price lists',
    pricesListsLowCase: 'price list',
    priceTo: 'Price to',
    productGenitive: 'product',
    productsPricesList: 'List of product prices',
    quantityFrom: 'Quantity from',
    quantityTo: 'Quantity to',
    removeAndReplacePrices: 'Delete prices and add again',
    savePriceErrorText: 'Price edit failed. Try again.',
    savePriceSuccessText: 'The selected price has been changed',
    savePriceSuccessTitle: 'Price changed',
    seePricelist: 'View price list',
    serviceGenitive: 'services',
    servicesPriceList: 'List of services prices',
    servicesPricesList: 'List of prices of services',
    setup: 'setup',
    setupPricesList: 'List of setup prices',
    supplierPricesFileNamePrefix: 'prices-suppliers-',
    unitPricesIn: 'prices per unit in',
    vat: 'VAT',
    vatRate: 'VAT rate',
    xlsxFileWithPrices: 'XLSX file with prices'
  },
  product: {
    actually: 'Real',
    actualPiecesInBox: 'Real units per box',
    addingMorePhotosAvailableAfterProductSave: 'Adding additional photos will be possible after saving the product.',
    addingNewIndentProduct: 'Adding new Indent product',
    addingNewProduct: 'Adding a new product',
    addingProductCardsAvailableAfterProductSave: 'Adding of product cards will be possible after saving the product.',
    addingTranslationsAvailableAfterProductSave: 'Adding of translations will be possible after saving the product.',
    addNewIndentProduct: 'Add a new Indent product',
    addNewProduct: 'Add a new product',
    addProduct: 'Add product',
    addMultipleProducts: 'Add multiple products',
    addProductCard: 'Add product card',
    addProductCardErrorText: 'Adding of a product card has failed. Please try again.',
    addProductCardSuccessText: 'The specified product card has been saved',
    addProductCardSuccessTitle: 'Product card added',
    addProductErrorText: 'Adding a product has failed. Please try again.',
    addProductSuccessText: 'The specified product has been saved',
    addProductSuccessTitle: 'Product added',
    addVariant: 'Add variant',
    addVariantPopup: {
      addVariant: 'Add variant',
      addVariantErrorText: 'An error occurred while adding the product variant. Please try again',
      addVariantSuccessText: 'Successfully added product variant',
      addVariantSuccessTitle: 'Variant added',
      fieldName: 'Field from main product',
      importPriceMethod: 'Price',
      importPriceMethods: {
        custom: 'Custom',
        other_child: 'From other variant',
        other_product: 'From other product',
        parent: 'From main product'
      },
      noProductsMatchingPhraseFound: 'No matching products found',
      noVariantsMatchingPhraseFound: 'No matching variants found',
      priceCode: 'Product price code',
      selectProduct: 'Select product',
      selectProductVariant: 'Select product variant',
      selectVariant: 'Select variant',
      title: 'Add product variant'
    },
    addVisualizationFile: 'Add a visualisation file',
    allProducts: 'All products',
    approve: 'Approve',
    automaticallySetSamplesDates: 'Automatically set sample dates',
    availabilityUpdating: 'Availability during the update',
    availableInPurchases: 'Available in purchases',
    availableQuantity: 'State',
    backToParentProduct: 'Back to parent product',
    breakProductsIntoSeparateOffers: 'Break down products into separate offers',
    cannotCopyToVariantsDesc: 'To copy data to variants you must select at least one product variant and at least one field to copy',
    cannotCopyToVariantsTitle: 'Copy operation cannot be done',
    cannotRemoveDuePurchaseDesc: 'Product has reservation in purchase from supplier. To remove this product, please remove first reservation from supplier purchase.',
    cannotRemoveDuePurchaseTitle: 'Product cannot be removed',
    checkAvailabilityInContainers: 'Check availability in containers',
    checkAvailabilityInOrders: 'Check availability in orders',
    chooseProduct: 'Choose product',
    collected: 'Collected',
    copyToVariants: 'Copy to variants',
    copyToVariants2: 'Copy to variants',
    copyToVariantsFailed: 'Copy operation failed',
    copyToVariantsTitle: 'Copy to variants',
    currentFile: 'Current file',
    dataCopiedDesc: 'Selected data has been copied to the selected product variants',
    dataCopiedTitle: 'Data copied',
    defaultServicesConfirm: {
      addForMultipleText: 'The products below have default services. Do you want to add them automatically?',
      addForMultipleTitle: 'Default services',
      cannotAddDefaultServicesText: 'Default services available for this product won\'t be added',
      cannotAddDefaultServicesTitle: 'Product contains configured services',
      doYouWantToAddDefaultServicesText: 'Do you want to add them automatically?',
      doYouWantToAddDefaultServicesTitle: 'Selected product contains default services',
      yesPleaseAdd: 'Yes, please add services'
    },
    deleteProductCardConfirmTitle: 'Are you sure you want to delete the selected product card?',
    deleteProductCardErrorText: 'Removing of a product card has failed. Please try again.',
    deleteProductCardSuccessText: 'The selected product card has been removed',
    deleteProductCardSuccessTitle: 'Product card removed',
    descriptionForCustomer: 'Description for customer on WWW',
    disableForCustomer: 'Disable in customer panel',
    disableForCustomerAPI: 'Disable in customer API',
    downloadVisualization: 'Download visualisation',
    doYouReallyWantCopyDataToVariantsDesc: 'This operation cannot be undone. From base product will be copied only data which has been saved. If you have some unsaved changes, please save them before copy operation.',
    doYouReallyWantCopyDataToVariantsTitle: 'Do you really want to copy data?',
    doYouWantEditPriceCode: 'Do you want to change the price code?',
    doYouWantEditPriceCodeInOtherProducts: 'Should this change also alter the price code in other products that use the current price code?',
    eanGtinCode: 'EAN / GTIN code',
    editIndentProduct: 'Edit Indent product',
    editProduct: 'Edit product',
    editProductCard: 'Edit product card',
    editProductCardErrorText: 'Product card edit failed. Please try again.',
    editProductCardSuccessText: 'The selected product card has been modified',
    editProductCardSuccessTitle: 'Product card modified',
    editProductErrorText: 'Product edit failed. Please try again.',
    editProductSuccessText: 'The selected product has been modified',
    editProductSuccessTitle: 'Product modified',
    editProductVariant: 'Edit product variant',
    embroideryEndedProductionAt: 'End of planned production',
    enterAdditionalProductDescriptionForCustomerOptional: 'Enter additional product description for customer (optional)',
    enterAdditionalProductDescriptionOptional: 'Enter additional product description (optional)',
    enterProductCodeForSearch: 'Enter the product code to search for',
    enterProductNameOrCode: 'Enter product name or code',
    fieldName: 'Field',
    fileName: 'File name',
    fileWithProducts: 'File with products',
    globalServices: 'Global services',
    importantPriceInfo: 'Important informations regarding product price',
    importantPriceInfoTitle: 'See important informations regarding price of this product',
    importPriceMethod: {
      custom: 'Custom price',
      other_child: 'From other variant',
      other_product: 'From other product',
      parent: 'From parent product'
    },
    includeDiscounts: 'Include in discounts',
    includeInServices: 'Include in services',
    inContainers: 'in containers',
    indentProduct: {
      cnCode: 'CN code',
      originCountry: 'Origin country',
      properties: 'Informations',
      type: 'Product type',
      types: {
        cap: 'Cap',
        none: 'None',
        winter: 'Winter cap'
      },
      weight: 'Weight'
    },
    inOrder: ' in the order',
    isSale: 'Product in sale',
    isSaleInfo: 'Product in sale, available while stocks last',
    linkToDropbox: 'Link to Dropbox',
    linkToWWWPage: 'Link to WWW page',
    lowAvailability: 'Low availability',
    mainProduct: 'main',
    minimalQty: 'Minimum quantity',
    moveToOffer: 'Transfer to offer',
    noPhotosForThisProduct: 'No photos available for this product',
    noPricesDefinedForThisProduct: 'No prices defined for this product',
    noProductCardsForThisProduct: 'No product cards for this product',
    noProductsMatchingGivenPhrase: 'No products matching the given phrase',
    noProductsToDisplay: 'No products to display',
    notIncludedInDiscounts: 'Not included in discounts',
    noTranslationsForThisProduct: 'No translations available for this product',
    numberOfItemsDamagedInProduction: 'Number of units damaged during production',
    piecesInBox: 'Pieces per carton',
    prductPriceCode: 'Product price code',
    priceCodeWillBeUpdatedInOtherProducts: 'The price code will also be updated in other products/variants that use the current price code',
    pricesListWillBeAvailableAfterProductSave: 'Prices list will be available after saving product',
    product: 'Product',
    productAvailability: 'Product availability',
    productCards: 'Product cards',
    productCode: 'Product code',
    productDefaultServices: 'Default services for product',
    productDescription: 'Product description',
    productDescriptionForCustomer: 'Product description for customer',
    productDuplicateErrorText: 'Product duplication failed. Please try again.',
    productImagesGallery: 'Product image gallery',
    productIncludesDefaultServices: 'Number of default services',
    productIndentBaseProduct: 'HPL base product',
    productName: 'Product name',
    productPhoto: 'Product image',
    productPrices: 'Product prices',
    productProcesVisibleAfterProductSave: 'Product prices will be visible after saving the product and adding them in the \"Price lists\" section',
    products: 'Products',
    productsApprovalList: 'List of products from sewing room for approval',
    productsCodes: 'Product codes',
    productsIndentList: 'List of Indent products',
    productsList: 'List of products',
    productsWithSamePriceCode: 'List of products/variants with the same price code',
    productTags: 'Product tags',
    productTranslations: 'Product translations',
    productVariantsToModify: 'Product variants to modify',
    productVisualizationFileNamePrefix: 'product-visualisation-',
    productWithGivenCodeNotFound: 'Product with the given code could not be found',
    properties: {
      chooseProcedure: 'Choose procedures',
      chooseStrand: 'Choose strand',
      color: 'Color',
      material: 'Material',
      noSuchProcedure: 'No such procedure',
      noSuchStrand: 'No such strand',
      procedures: 'Procedures',
      sizes: 'Sizes',
      strand: 'Strand'
    },
    purchaseIsRequiredForZZProduct: 'For this product, it is required to create/connect purchase',
    quantityAvailableAtTimeOfOrdering: 'Available quantity at the time of placing the order {quantity} pcs.',
    recordProductionDamage: 'Take note of production damage',
    rememberAboutVariants: 'After save, please make sure that there is no need to copy changes to the variants of this product.',
    removeAllProducts: 'Remove all products',
    removeProductConfirmTitle: 'Are you sure you want to delete this product?',
    removeProductErrorText: 'Product removal failed. Please try again.',
    removeProductSuccessText: 'The selected product has been removed',
    removeProductSuccessTitle: 'Product removed',
    removeVariantConfirmTitle: 'Are you sure you want to delete this variant?',
    removeVariantErrorText: 'Variant removal failed. Please try again.',
    removeVariantSuccessText: 'The selected variant has been removed',
    removeVariantSuccessTitle: 'Variant removed',
    reservationAssignmentRemoveFail: 'Remove operation failed',
    reservationAssignmentRemoveFailDesc: 'Please try again or please check purchase',
    reservationAssignmentRemoveSuccess: 'Assignment removed',
    reservationAssignmentRemoveSuccessDesc: 'Assignment has been successfully removed from purchase',
    reservationRemoveAssignmentFailDesc: 'Assignment remove operation failed',
    reservationRemoveAssignmentQuestion: 'Do you really want to remove assignment?',
    reservationRemoveAssignmentQuestionDesc: 'This operation cannot be undone.',
    reservationRemoveFail: 'Reservation remove failed',
    reservationRemoveFailDesc: 'Reservation has not been removed',
    reservationRemoveFromPurchaseErrorDesc: 'Remove operation failed.',
    reservationRemoveFromPurchaseFail: 'Remove operation failed',
    reservationRemoveFromPurchaseFailDesc: 'Please try again or please check purchase',
    reservationRemoveFromPurchaseQuestion: 'Do you really want to remove product from purchase?',
    reservationRemoveFromPurchaseQuestionDesc: 'This operation cannot be undone. If it is the only product in purchase, the purchase will be also removed.',
    reservationRemoveFromPurchaseSuccess: 'Removed',
    reservationRemoveFromPurchaseSuccessDesc: 'Product has been successfully removed from purchase.',
    reservationRemoveQuestion: 'Do you really want to remove this reservation?',
    reservationRemoveQuestionDesc: 'This operation cannot be undone.',
    reservationRemoveSuccess: 'Reservation removed successfully',
    reservationRemoveSuccessDesc: 'The selected reservation has been removed successfully.',
    saleNoteForNonParentProduct: 'This param can be edited only in the main product',
    saleNoteForParentProduct: 'This param will be set also in variants',
    seeSamePriceCodeProducts: 'see these products',
    selectFileWithVisualizationOptional: 'Select a visualisation file (optional)',
    selectProduct: 'Select a product',
    shouldBeCopied: 'Copy?',
    shouldBeModified: 'Modify?',
    siteDescription: 'Description for WWW',
    stateHistory: {
      availableAfterProductSave: 'State history will be available after saving product.',
      date: 'Date',
      itemType: {
        CHANGED_IN_ORDER: 'Changed in order',
        CHANGED_STOCK: 'Stock changed',
        DELETED_IN_ORDER: 'Deleted in order'
      },
      loadHistory: 'Load product state history',
      order: 'Order',
      quantity: 'State',
      stateHistoryTitle: 'Product state history',
      tabTitle: 'State history',
      type: 'Change type'
    },
    tag: {
      addCategoryErrorText: 'Adding a tag category has failed. Please try again.',
      addCategorySuccessText: 'The specified tag category has been saved',
      addCategorySuccessTitle: 'Category added',
      addingTagsAvailableAfterProductSave: 'Adding tags will be possible after saving the product.',
      addNewCategory: 'Add a new category',
      addNewTagCategory: 'Adding a new tag category',
      addTag: 'Add a tag',
      addTagCategory: 'Add a tag category',
      categoryName: 'Category name',
      categoryOrderChangeErrorText: 'Failed to save the changes to the category order.',
      categoryTranslations: 'Category translations',
      deleteTagConfirmTitle: 'Are you sure you want to delete this tag?',
      deleteTagErrorText: 'Deleting a tag has failed. Please try again.',
      deleteTagSuccessText: 'The selected tag has been deleted',
      deleteTagSuccessTitle: 'Tag removed',
      editCategoryErrorText: 'Updating a tag category has failed. Please try again.',
      editCategorySuccessText: 'The specified tag category has been updated',
      editCategorySuccessTitle: 'The category has been updated',
      editingTagCategory: 'Editing tag categories',
      editTagCategory: 'Edit tag category',
      enterNewTagName: 'Enter the new tag name',
      isMain: 'Main category',
      mainCategories: 'Main categories',
      mainCategoriesDesc: 'Select the main categories within which the "{name}" category is to be displayed during the product selection stage in the customer panel:',
      name: 'Tag name',
      noAvailableTags: 'No tags available',
      noAvailableTagsForThisCategory: 'No tags available in this category',
      noMatchingTagsFound: 'No matching tags found',
      noTagCategoriesToDisplay: 'No tag categories to display',
      noTagsInThisCategory: 'No tags in this category',
      noTranslationsForThisTagCategory: 'No translations for this tag category',
      noTranslationsForThisTags: 'No translations for tags in this tag category',
      numberOfTags: 'Number of tags',
      productTags: 'Product Tags',
      removeCategoryConfirmTitle: 'Are you sure you want to delete this category?',
      removeCategoryErrorText: 'Deleting a category has failed. Please try again.',
      removeCategorySuccessText: 'The selected category has been deleted',
      removeCategorySuccessTitle: 'Category deleted',
      showAsList: 'Display as list',
      showAsTree: 'Display categories hierarchy',
      tagAddedSuccessText: 'The specified tag has been added',
      tagAddedSuccessTitle: 'Added tag',
      tagCategoriesList: 'List of tag categories',
      tagEditSuccessText: 'The specified tag has been changed',
      tagEditSuccessTitle: 'Tag changed',
      tagManagemnetAvailableAfterCategorySave: 'Tag management will be available after saving the category.',
      tagNameCannotBeEmpty: 'The tag name cannot be empty',
      tagTranslations: 'Tag translations',
      withoutMainCategory: 'Categories without parent categories'
    },
    totalProductsCostNet: 'Total cost of products (net)',
    usedByXOtherProducts: 'Number of products and variants which uses the same price code: {count}',
    valuesToUseInVariants: 'Values to copy to variants',
    variantProduct: 'variant',
    variants: 'Variants',
    variantsCount: 'Variants',
    variantValuesWillBeReplacedDuringCopyOperation: 'Data in variants will be REPLACED with data from the base product during copy operation.',
    visualizationTemplate: 'Visualization template',
    yesCopyData: 'Yes, copy data',
    youMustSaveOrderToSaveReservations: 'Warning! To save above reservations changes you must save the order.'
  },
  productCategories: {
    addCategory: 'Add Category',
    addCategoryErrorText: 'An error occurred while adding the category...',
    addCategorySuccessText: 'Category added',
    addCategorySuccessTitle: 'New category has been successfully added...',
    additionalCategories: 'Additional categories',
    addTranslation: 'Add translation',
    categories: 'Categories',
    editCategory: 'Edit category',
    editCategoryErrorText: 'An error occurred while editing the category...',
    editCategorySuccessText: 'Category modified',
    editCategorySuccessTitle: 'Selected category has been modified',
    mainCategory: 'Main category',
    name: 'Category Name',
    noCategoriesToDisplay: 'No product categories to display...',
    noMainCategory: 'No main category',
    noParentCategory: 'No parent category',
    noTranslationsForThisCategory: 'No category translations to display...',
    parentCategory: 'Parent category',
    removeCategoryConfirmTitle: 'Are you sure you want to remove the selected category?',
    removeCategoryErrorText: 'An error occurred while removing the category...',
    removeCategorySuccessText: 'The selected product category has been successfully removed.',
    removeCategorySuccessTitle: 'Category Removed',
    selectMainCategory: 'Select main category',
    title: 'Product Categories',
    translations: 'Translations'
  },
  purchase: {
    addCommentsToOrder: 'Add notes to your order',
    addingOrderInProgress: 'Adding an order in progress',
    addNew: 'Add new',
    addOrder: 'Add an order',
    addOrderErrorText: 'Adding an order has failed. Please try again.',
    addOrderErrorTitle: 'An error occurred while adding an order',
    addOrderForProduct: 'Add a product order',
    addOrderSuccessText: 'PThe specified order has been added',
    addOrderSuccessTitle: 'Order added',
    addProductOrderSuccessText: 'An order for the selected product has been added.',
    addProductOrderToOrderSuccessText: 'The order for the selected product has been added to the selected order.',
    addProductOrderToOrderSuccessTitle: 'Added to order',
    addProductsToExistingOrder: 'Add products to an existing order',
    addProductToOrderErrorTitle: 'An error occurred while adding a product to your order',
    allProductsReceived: 'All products received',
    assignProductToExistingOrder: 'Assign a product to an existing order',
    available: 'Available',
    awaitingPayment: 'Awaiting payments',
    awaitingProducts: 'Awaiting products',
    bookIt: 'Book it',
    closed: 'Closed',
    closeOrder: 'Close the order',
    contains: 'contains',
    customerType: 'Maker',
    customerTypeCustomer: 'Maker 2',
    customerTypeSubCustomer: 'Maker 1',
    description: 'Description',
    downloadFile: 'Download file',
    downloadInvoice: 'Download the invoice',
    editOrder: 'Edit the order',
    editOrderErrorText: 'Failed to edit the order. Please try again.',
    editOrderSuccessText: 'The specified order has been modified',
    editOrderSuccessTitle: 'The order has been saved',
    enterInvoiceNumber: 'Enter invoice number',
    enterOrderName: 'Enter order name',
    erpNumber: 'PZ number',
    existingOrdersDesc: 'Orders already exist for the selected makers configuration, to which this product can be added. Are you sure you want to create a new order?',
    existingOrdersPleaseAdd: 'Yes, create',
    existingOrdersTitle: 'Existing orders available for use',
    fabric: {
      addFabricColorErrorText: 'An error occurred while adding a fabric colour',
      addFabricColorSuccessText: 'New fabric colour for sewing rooms added',
      addFabricColorSuccessTitle: 'Added fabric colour',
      addFabricErrorText: 'An error occurred while adding fabric',
      addFabricSuccessText: 'New fabric for sewing rooms added',
      addFabricSuccessTitle: 'Fabric added',
      chooseColor: 'Select a colour',
      chooseFabric: 'Select fabric',
      color: 'Colour',
      fabric: 'Fabric',
      fabricColor: 'Fabric colour',
      noSuchColor: 'No such colour',
      noSuchFabric: 'No such fabric'
    },
    fileDeletedDesc: 'Selected file has been deleted',
    fileDeletedTitle: 'File deleted',
    finished: 'Completed',
    fleece: {
      addFleeceErrorText: 'An error occurred while adding a fleece',
      addFleeceSuccessText: 'New fleece added for the sewing room',
      addFleeceSuccessTitle: 'Fleece added',
      chooseFleece: 'Select a fleece',
      fleece: 'Fleece',
      noSuchFleece: 'No such fleece'
    },
    forceOrderClose: 'Force closure',
    forceOrderCloseConfirmText: 'Are you sure you want to force close this order? The conditions required to correctly close an order will NOT be verified in this case.',
    forceOrderCloseConfirmTitle: 'Forcing closure of the order',
    forceOrderCloseErrorText: 'Failed to force the order to close. Try again.',
    inOrder: 'In the order',
    invoiceDate: 'Invoice date (Maker 2)',
    invoiceFile: 'Invoice file (Maker 2)',
    invoiceFileNamePrefix: 'invoices',
    invoiceNumber: 'Invoice number (Maker 2)',
    new: 'New',
    newOrder: 'New order',
    noDeliveryDate: 'No delivery date',
    noOrdersToDisplay: 'No orders to display',
    noOrdersWithSufficientProductQuantityFound: 'No orders were found from suppliers with sufficient quantities of the selected product.',
    noPeopleAssignedToSupplier: 'No persons assigned to the supplier.',
    noPurchases: 'No purchases',
    noPurchasesMatchingPhrase: 'No purchases matching the given phrase',
    noSewingRoomLogs: 'No informations about sync with sewing room',
    noSuchOrder: 'No such order',
    noSupplierMarchingPhraseFound: 'No suppliers matching the given phrase',
    notifications: {
      createdAt: 'Send date',
      emailNotifications: 'Sent notifications',
      noEmailNotifications: 'No sent notifications',
      receiver: 'Receiver',
      sendingType: 'Sending type',
      sendingTypes: {
        AUTO: 'Automatically',
        MANUALLY: 'Manually'
      },
      type: 'Type',
      types: {
        PRODUCTS_REMINDER: 'Reminder about products delivery',
        SUPPLIER_INVOICE: 'Request for invoice'
      },
      userName: 'Worker'
    },
    notificationSentDesc: 'Notification about changes in this purchase has been sent',
    notificationSentTitle: 'Notification sent',
    numberOfOrders: 'Number of orders',
    numberOfPiecesNeeded: 'Number of pieces required',
    orderCloseErrorText: 'The closing of the order has failed.',
    orderCloseErrorTextTryAgain: 'The closing of the order has failed. Please try again.',
    orderCloseErrorTitle: 'The order could not be closed',
    orderIDInSewing: 'Order ID (Maker 2)',
    orderIDInSubSewing: 'Order ID (Maker 1)',
    ordersFromSuppliers: 'Orders from suppliers',
    ordersSearchInProgress: 'Order search in progress',
    parentPurchaseRemoved: 'Related parent purchase has been removed. Add relation again if it is required.',
    productsReceivedDate: 'Products received at ',
    productsReceivedInOrder: 'in order',
    productsToOrder: 'Products to be ordered',
    purchase: 'Purchase',
    purchaseCategory: 'Purchase category',
    purchases: 'Purchases',
    purchaseStatus: 'Purchase status',
    purchasesXlsFilename: 'purchases-list',
    purchaseType: {
      domestic: 'Domestic',
      import: 'Import'
    },
    pzFor: 'PZ generated for',
    receivedAt: 'Date of receive from maker 2',
    relation: {
      cannotBeAssignedToParent: 'This purchase cannot be assigned to the parent purchase',
      childrenPurchases: 'Children purchases',
      openThisPurchase: 'Open this purchase',
      parentPurchase: 'Parent purchase'
    },
    relations: 'Related purchases',
    removeFile: 'Delete file',
    removeFileInProgress: 'Deleting file',
    removeInvoice: 'Delete invoice',
    removeProductText: 'First remove related products to be able to remove this product',
    requiresShape: 'Requires a pattern',
    reservation: {
      cannotBeRemoved: 'This reservation cannot be removed',
      cannotBeRemovedDesc: 'Check your order with supplier {customerName} as products ordered there are used in many orders',
      listOfReservationsFormOrdersWithSuppliers: 'List of reservations from orders with suppliers',
      noPurchasesReservationsToDisplay: 'No purchase reservations to display',
      removeAssignment: 'Remove assignment',
      removeFromPurchase: 'Remove product from purchase',
      removeReservations: 'Delete a booking',
      reservedInOrder: 'Booked in the order'
    },
    saveOrder: 'Save the order',
    saveOrderToBookProducts: 'Save order to reserve products',
    searchProductInOrders: 'Search for a product in orders',
    seeOrderInSewingRoom: 'View the order - Maker 2',
    seeOrderInSubSewingRoom: 'View the order - Maker 1',
    selectInvoiceFile: 'Select invoice file (optional)',
    selectParentPurchase: 'Select parent purchase',
    selectPurchase: 'Select purchase',
    sendPurchaseEmail: 'Send notification',
    sendPurchaseEmailCustomer: 'To maker 2',
    sendPurchaseEmailSubCustomer: 'To maker 1',
    sewingRoomLogs: 'Sync with makers',
    sewingRoomLogTypeStatus: 'Status change',
    sewingRoomLogTypeSynchronize: 'Synchronize',
    sewingRoomStatusChanged: 'Status changed to ',
    sewingRoomSynchronized: 'Purchase synchronization',
    shapeStaysInHafciarnia: 'The pattern stays in the Hafciarnia',
    size: {
      addSizeErrorText: 'An error occurred while adding the size',
      addSizeSuccessText: 'New size added for sewing room',
      addSizeSuccessTitle: 'Size added',
      noSuchSize: 'No such size',
      selectSize: 'Select size',
      size: 'Size'
    },
    statusInSewingRoom: 'Status (Maker 2)',
    statusInSubSewingRoom: 'Status (Maker 1)',
    statusLogs: 'Status history',
    stitching: {
      addStitchingErrorText: 'An error occurred while adding a stitching',
      addStitchingSuccessText: 'New stitching for the sewing room added',
      addStitchingSuccessTitle: 'Stitching added',
      chooseStitching: 'Select stitching',
      noSuchStitching: 'No such stitching',
      stitching: 'Stitching'
    },
    subInvoiceDate: 'Invoice date (Maker 1)',
    subInvoiceFile: 'Invoice file (Maker 1)',
    subInvoiceNumber: 'Invoice number (Maker 1)',
    suborderReceivedAt: 'Date of receive from maker 1',
    supplierChanged: 'Makker changed',
    supplierChangedDesc: 'It is necessary to verify prices of products which has been added to this order before changing maker.',
    syncDate: 'Synchronisation date',
    syncDateSubSewing: 'Synchronisation date (Maker 1)',
    warehouse: 'Warehouse',
    yesClose: 'Yes, close',
    yourOrderSaveSuccessText: 'Your order has been saved'
  },
  purchaseEditPopup: {
    newPurchaseQuantity: 'New product quantity in purchase',
    newQuantity: 'Necessary quantity of product',
    order: 'Order',
    purchaseValueTooLow: 'Quantity in purchase cannot be lower than total reserved quantity.',
    reservedProductsForOrderAmount: 'Quantity reserved for this order',
    sewingRoomStatus: 'Purchase status ({name})',
    sewingRoomSyncDate: 'Synchronization date',
    sewingRoomSynced: 'Purchase is synchronised ({name})',
    subSewingRoomStatus: 'Purchase status ({name})',
    subSewingRoomSyncDate: 'Synchronization date',
    subSewingRoomSynced: 'Purchase is synchronised ({name})',
    title: 'Edit purchase',
    totalOrderedProductsAmount: 'Total quantity ordered in purchase',
    totalReservedProductsAmount: 'Total quantity reserved in orders'
  },
  report: {
    dailyReport: 'Daily report',
    dateRange: 'Date range',
    generateReport: 'Generate report',
    purchasesReports: 'Purchase report',
    reports: 'Reports',
    reportsGenerating: 'Generating reports',
    reportType: 'Report type'
  },
  selectTag: {
    enterTag: 'Enter tag name',
    errorOccurred: 'An error occurred during loading data',
    noTagsMatchingGivenPhrase: 'No tags matching given phrase'
  },
  service: {
    addDescriptionForCustomer: 'Add description for customer',
    addingTransialtionsAvailableAfterSave: 'Adding translations will be possible after saving the service...',
    addNewIndentService: 'Add a new Indent service',
    addNewService: 'Add a new service',
    addService: 'Add service',
    addServiceErrorText: 'Adding a service has failed. Please try again.',
    addServiceSuccessText: 'The service has been added',
    addServiceSuccessTitle: 'Added service',
    addVariant: 'Add a variant',
    attachSelectdServicesPricesLists: 'Attach price lists of selected services',
    availableInHafciarnia: 'Available in Hafciarnia',
    catalogUrl: 'Link to the engraved leather catalogue',
    checkEstimatedDate: 'Check available dates',
    chooseEmbroideryPosition: 'Choose service position',
    chooseEmbroideryType: 'Choose service type',
    chooseService: 'Select service',
    commonServices: 'Common services',
    dateChangeErrorText: 'Date change {value} failed. Please try again.',
    dateSaved: 'Date saved',
    daysNoSampleIndent: 'Email reminders',
    daysNoSampleIndentAppend: 'days without a sample',
    daysNoSampleIndentPrepend: 'Email after',
    daysToSample: 'Days to prepare sample',
    deleteConfirmTitle: 'Are you sure you want to delete this service?',
    deleteErrorText: 'Service removal failed. Please try again.',
    deleteSuccessText: 'The specified service has been removed',
    deleteSuccessTitle: 'Service removed',
    descriptionFoCustomer: 'Description for the customer',
    detailsOfServiceInOrder: 'Details of services in the order',
    dropboxCatalog: 'Dropbox catalog',
    dstNumber: 'DST number',
    editIndentService: 'Edit Indent service',
    editService: 'Edit HPL service',
    editVariant: 'Edit variant',
    embroidery: {
      colors: 'EMBRY COLORS',
      height: 'HEIGHT',
      position: 'EMBRY POSITION',
      size: 'EMBRY SIZE',
      type: 'EMBRY TYPE',
      width: 'WIDTH'
    },
    enterAdditionalServiceDescription: 'Enter additional service description',
    enterAdditionalServiceDescriptionForCustomer: 'Enter an additional description of the service for the customer',
    enterServiceCodeOrUseSearch: 'Enter a service code or use the search engine',
    estimatedCompleteDate: 'Estimated production date',
    estimationIssueText: 'System is unable to specify nearest production date for this service',
    estimationIssueTitle: 'Unable to specify date',
    files: {
      addFile: 'Add file(s)',
      addFiles: 'Add files',
      addingFile: 'Adding file',
      cancelAddingFile: 'Cancel adding file',
      cannotAddFiles: 'Files can be added only to services which are saved. Please save this order to add files to this service.',
      deleteFile: 'Delete file',
      editFile: 'Edit file',
      editFileText: 'Please provide updated description for the file',
      editFileTitle: 'Change file description',
      fileEditedTitle: 'File has been edited',
      fileEditError: 'An error occurred during file edit. Please try again.',
      fileName: 'File description',
      fileNameCannotBeEmpty: 'File description cannot be empty',
      noFilesToDisplay: 'No files for this service',
      removeFileDesc: 'This operation cannot be undone',
      removeFileTitle: 'Do you really want to remove this file?',
      selectFileToUpload: 'Please select file(s) to add',
      title: 'Service files',
      uploadError: 'An error occurred during adding file'
    },
    filterServicesByName: 'Filter services by name',
    fromHowManyPiecesThePriceIsMultiplied: 'From how many pieces multiply the price',
    group: {
      addGroup: 'Add a group',
      addingServiceVariantsAvailableAfterSave: 'Adding service variants will be possible after saving an service group...',
      addingTransialtionsAvailableAfterSave: 'Adding translations will be possible after saving the service group...',
      addNewGroup: 'Add new group',
      addNewServiceGroup: 'Add a new service group',
      addServiceGroupErrorText: 'Adding a service group has failed. Please try again.',
      addServiceGroupSuccessText: 'The specified service group has been added',
      addServiceGroupSuccessTitle: 'Service group added',
      assortmentGroup: 'Assortment group',
      assortmentGroupName: 'Name of assortment group',
      editServiceGroup: 'Editing a service group',
      enterServiceGroupNameOrCode: 'Enter the name or code of the service group',
      groupCode: 'Group code',
      groupName: 'Group name',
      noServicesGroupsToDisplay: 'No service groups to display',
      noTranslationsForThisServiceGroup: 'No translation for this service group',
      numberOfServices: 'Number of services in package',
      numberOfVariants: 'Number of variants',
      removeServiceGroupConfirmTitle: 'Are you sure you want to delete this service group?',
      removeServiceGroupErrorText: 'Deletion of service group failed. Please try again.',
      removeServiceGroupSuccessText: 'The specified service group has been deleted',
      removeServiceGroupSuccessTitle: 'Service group deleted',
      serviceGroupCode: 'Service group code',
      serviceGroupName: 'Name of service group',
      serviceGroupPhoto: 'Picture of a service group',
      servicesGroupsList: 'List of service groups',
      servicesVariants: 'Service variants',
      showOnlyPackages: 'Show only services packages',
      updateServiceGroupErrorText: 'Modifying a service group has failed. Please try again.',
      updateServiceGroupSuccessText: 'The given service group has been modified',
      updateServiceGroupSuccessTitle: 'The service group has been modified'
    },
    height: 'Height',
    isPackage: 'Service package',
    issueDuringEstimation: 'System is unable to specify nearest production date',
    machines: 'Maszyna',
    noPricesForThisService: 'No prices for this service',
    noServicesMatchingPhrase: 'No services matching the given phrase',
    noServicesToDisplay: 'No services to display',
    noSetupPricesForThisService: 'No setup prices for this service',
    noTranslationsForThisService: 'No translation for this service',
    priceAlwaysApiece: 'Price always per piece',
    priceForAll: 'price for total',
    productionCompleteDate: 'Production end date',
    productionFinish: 'production end',
    sample: {
      acceptBothEmbrioderySample: 'Sample accept',
      acceptEmbrioderySample: 'HPL accept - send to client',
      draftDate: 'Draft receive date',
      provideRejectionReason: 'Provide rejection reason',
      rejectEmbrioderyHistory: 'Sample history',
      rejectEmbrioderySample: 'No HPL accept',
      rejectHistory: 'Rejection history',
      rejectionDate: 'Rejection date',
      rejectionReason: 'Rejection reason',
      rejectionReasonCannotBeEmpty: 'Rejection reason cannot be empty',
      rejectionStatus: 'Status',
      rejectSample: 'Reject sample',
      requiresDraft: 'Draft required',
      sampleAccept: 'acceptance of the sample',
      sampleAcceptConfirmText: '',
      sampleAcceptConfirmTitle: 'Are you sure you want to accept this sample?',
      sampleAcceptDate: 'Date of sample acceptance',
      sampleAcceptErrorText: 'Accept sample failed. Please try again.',
      sampleAcceptSuccessTitle: 'Sample accepted',
      sampleDate: 'Sample date',
      sampleHplAcceptedAt: 'Sample acceptance date:',
      samplePhotosDateCreated: 'Date added',
      samplePhotosDownload: 'Download',
      samplePhotosDownloadAll: 'Download all',
      samplePhotosSeePreview: 'See sample photo',
      samplePhotosTitle: 'Photos of samples',
      sampleReceive: 'receiving the sample',
      sampleReceiveDate: 'Date of sample receipt',
      sampleRejectConfirmText: 'Rejecting a sample will clear the dates of the sample',
      sampleRejectConfirmTitle: 'Are you sure you want to reject this sample?',
      sampleRejectErrorText: 'Reject sample failed. Please try again.',
      sampleRejectSuccessTitle: 'Sample rejected',
      sampleStatus: 'Sample status',
      sampleStatuses: {
        approved: 'Approved',
        rejected: 'Rejected',
        waiting: 'Waiting'
      },
      yesAccept: 'Yes, accept',
      yesReject: 'Yes, reject'
    },
    sampleFiles: {
      addingFile: 'Add file',
      deleteFile: 'Delete file',
      fileDeletedDesc: 'Successfully deleted the selected file',
      fileDeletedTitle: 'File deleted',
      removeFileDesc: 'This operation cannot be undone',
      removeFileTitle: 'Are you sure you want to delete this file?',
      title: 'Sample files',
      uploadError: 'File upload failed'
    },
    samples: {
      add: 'Add sample',
      hideFiles: 'Hide files ({count})',
      noSamples: 'No samples',
      rejectReason: 'Reason for rejection',
      sample: 'Sample',
      saveBeforeAddingFiles: 'Save the order to add files',
      showFiles: 'Show files ({count})',
      status: 'Sample status',
      statuses: {
        accepted: 'Accepted',
        rejected: 'Rejected'
      },
      title: 'Decorating samples'
    },
    schedule: {
      monthlyView: 'Monthly view',
      planningServices: 'Services planning',
      weeklyView: 'Weekly view'
    },
    searchServices: 'Search for service',
    selectService: 'Select service',
    selectServiceType: 'Select service type',
    sericesAdded: 'Added services',
    service: 'Service',
    serviceAndContractor: 'Service and contractor',
    serviceCode: 'Service code',
    serviceDescription: 'Service description',
    serviceDescriptionForCustomer: 'Service description for customer',
    serviceGroup: 'Service group',
    serviceName: 'Name of service',
    servicePreview: 'Service preview',
    servicePrices: 'Prices for service',
    servicePricesVisibleAfterSave: 'The prices of services will be visible after saving it ...',
    services: 'Services',
    serviceSearchPlaceholder: 'Enter service name or code',
    servicesGroup: 'Services group',
    servicesIndentList: 'List of Indent services',
    servicesList: 'List of HPL services',
    servicesSearchInstructionInfo: 'Search for services for which you would like to know the price.<br>You can search for services by entering a service code or use the service search engine.',
    serviceType: 'Service type',
    serviceWithoutGroup: 'Service without group',
    setup: 'Setup',
    setupPrice: 'Koszt Setup',
    setupPrices: 'Setup prices',
    setupPricesVisibleAfterSave: 'Setup prices will be visible after saving the service...',
    stitchNumber: 'Stitch number',
    strandColors: 'Strand colors',
    updateServiceErrorText: 'Service modification failed. Please try again.',
    updateServiceSuccessText: 'The selected service has been modified',
    updateServiceSuccessTitle: 'The service has been modified',
    wantToUseServices: 'I want to use services',
    yourCommentsOnServiceOptional: 'Your comments on the execution of the service (optional)'
  },
  settings: {
    backToSettings: 'Back to settings',
    confirmations: {
      addConfirmation: 'Add confirmation',
      addConfirmationErrorText: 'Failed to add the confirmation',
      addConfirmationSuccessText: 'The confirmation has been added',
      addConfirmationSuccessTitle: 'Confirmation added',
      addNewConfirmation: 'Add new confirmation',
      confirmationName: 'Confirmation content',
      confirmations: 'Additional confirmations',
      customers: 'For customers',
      editConfirmation: 'Edit confirmation',
      editConfirmationErrorText: 'Failed to update the confirmation',
      editConfirmationSuccessText: 'The confirmation has been updated',
      editConfirmationSuccessTitle: 'Confirmation updated',
      name: 'Confirmation content',
      noConfirmationsToDisplay: 'No confirmations to display',
      products: 'For products',
      productsOrCustomersRequired: 'You must select at least one customer or at least one product linked to the confirmation',
      removeConfirmationConfirmTitle: 'Are you sure you want to remove this confirmation?',
      removeConfirmationErrorText: 'Failed to remove the confirmation',
      removeConfirmationSuccessText: 'The selected confirmation has been removed',
      removeConfirmationSuccessTitle: 'Confirmation removed',
      searchProducts: {
        addFoundedProducts: 'Add products',
        foundedProducts: 'Founded products',
        noProductsFounded: 'No matching products',
        search: 'Search products',
        searchProducts: 'Search products',
        title: 'Search products'
      },
      selectedCustomerExists: 'This customer has already been selected',
      selectedProductExists: 'This product has already been selected'
    },
    country: {
      addCountry: 'Add country',
      addCountryErrorText: 'Adding country failed. Please try again.',
      addCountrySuccessText: 'The specified country has been added',
      addCountrySuccessTitle: 'Country added',
      addingTranslationsAvailableAfterSave: 'Please save the country to add translations',
      addNewCountry: 'Add a new country',
      countries: 'Countries',
      country: 'Country',
      countryAddressCode: 'Code for address',
      countryCode: 'Country code',
      countryEditErrorText: 'Failed to edit the country. Please try again.',
      countryEditSuccessText: 'The specified country has been changed',
      countryEditSuccessTitle: 'Country modified',
      countryInvoiceCode: 'Code for invoice',
      countryName: 'Country name',
      editCountry: 'Edit country',
      EU: 'EU?',
      isEU: 'Is country in European Union?',
      noCountriesToDisplay: 'No countries to display',
      noTranslationsForThisCountry: 'No country translations to display',
      removeCountryConfirmTitle: 'Are you sure you want to delete this country?',
      removeCountryErrorText: 'Country removal failed. Please try again.',
      removeCountrySuccessText: 'The specified country has been deleted',
      removeCountrySuccessTitle: 'Country deleted',
      selectCountry: 'Select country',
      taxNumberCheck: 'Check VAT ID?',
      translations: 'Translations',
      verifyTaxNumber: 'Should verify NIP/VAT?'
    },
    currency: {
      addCurrency: 'Add currency',
      addCurrencyErrorText: 'Adding currency has failed. Please try again.',
      addCurrencySuccessText: 'The specified currency has been added',
      addCurrencySuccessTitle: 'Currency added',
      addingTranslationsAvailableAfterSave: 'Please save the currency to add translations',
      addNewCurrency: 'Add a new currency',
      chooseCurrency: 'Select a currency',
      currencies: 'Currencies',
      currency: 'Currency',
      currencyCode: 'Currency code',
      currencyName: 'Name of currency',
      currencyTextWarningText: '<strong> Attention! </strong> If the currency is changed, the prices of products, services and shipments will be loaded again in the selected currency.',
      editCurrency: 'Edit the currency',
      editCurrencyErrorText: 'Failed to edit the currency. Please try again.',
      editCurrencySuccessText: 'The specified currency has been changed',
      editCurrencySuccessTitle: 'Currency modified',
      noCurrenciesAvailable: 'No currencies available...',
      noCurrenciesToDisplay: 'No currencies to display',
      noTranslationsForThisCurrency: 'No currency translations to display',
      removeCurrencyConfirmTitle: 'Are you sure you want to delete this currency?',
      removeCurrencyErrorText: 'Deletion of currency has failed. Please try again.',
      removeCurrencySuccessText: 'The specified currency has been deleted',
      removeCurrencySuccessTitle: 'Currency removed',
      translations: 'Translations'
    },
    customerContactTypes: {
      addCustomerContactTypeErrorText: 'An error occurred during adding new type of contact with customer',
      addCustomerContactTypeSuccessText: 'New type of contact with customer has been added',
      addCustomerContactTypeSuccessTitle: 'New type of contact added',
      addingTranslationsAvailableAfterSave: 'Please save the contact type to add translations',
      addNewCustomerContactType: 'Add new type of contact',
      contactTypes: 'Type of contacts with customers',
      editCustomerContactType: 'Save changes',
      editCustomerContactTypeErrorText: 'An error occurred during editing type of contact with customer',
      editCustomerContactTypeSuccessText: 'Type of contact with customer has been modified',
      editCustomerContactTypeSuccessTitle: 'Type of contact modified',
      icon: 'Icon',
      isDefault: 'Default?',
      name: 'Name',
      noContactTypesToDisplay: 'No types of contact to display',
      noTranslationsForThisCurrency: 'No contact type translations to display',
      removeContactTypeConfirmTitle: 'Do you really want to remove this type of contact with customer?',
      removeContactTypeErrorText: 'An error occurred during type of contact removal',
      removeContactTypeSuccessText: 'Type of contact with customer has been removed',
      removeContactTypeSuccessTitle: 'Type of contact removed',
      removeIcon: 'Remove icon',
      translations: 'Translations',
      type: 'Type'
    },
    customerTags: {
      addCustomerTag: 'Add a customer tag',
      addCustomerTagErrorText: 'Adding a customer tag has failed. Please try again.',
      addCustomerTagSuccessText: 'Customer tag has been added',
      addCustomerTagSuccessTitle: 'Customer tag added',
      addingTranslationsAvailableAfterSave: 'Please save the tag to add translations',
      addNewCustomerTag: 'Add a new customer tag',
      customersTags: 'Customers tags',
      customerTags: 'Customer tags',
      editCustomerTag: 'Edit customer tag',
      editCustomerTagErrorText: 'Editing a customer tag has failed. Please try again.',
      editCustomerTagSuccessText: 'The specified customer tag has been changed',
      editCustomerTagSuccessTitle: 'Customer tag modified',
      noTagsToDisplay: 'No customer tags to display',
      noTranslationsForThisCustomerTag: 'No tag translations to display',
      removeTagConfirmTitle: 'Are you sure you want to delete this customer tag?',
      removeTagErrorText: 'Customer tag removal failed. Please try again.',
      removeTagSuccessText: 'The specified customer tag has been removed',
      removeTagSuccessTitle: 'Customer tag removed',
      tagColor: 'Tag colour',
      tagDescription: 'Tag description',
      taggedCustomers: 'Customers count',
      tagName: 'Name of tag',
      tagNameAndDescription: 'Tag name and description',
      translations: 'Translations'
    },
    emailTemplates: {
      addEmailTemplateErrorText: 'Adding the email template failed - please try again.',
      addEmailTemplateSuccessText: 'Email template has been saved',
      addEmailTemplateSuccessTitle: 'Template added',
      additionalInfo: 'Additional info',
      addNewEmailTemplate: 'Add new email template',
      address1: 'Adress',
      address2: 'Adress (additiona info)',
      companyName: 'Company name',
      editEmailTemplate: 'Edit email template',
      editEmailTemplateErrorText: 'Editing the email template failed - please try again.',
      editEmailTemplateSuccessText: 'Email template has been updated',
      editEmailTemplateSuccessTitle: 'Template saved',
      email: 'E-mail',
      emailTemplates: 'Email templates',
      excludedCustomers: 'Excluded customers',
      excludedCustomersInfo: 'Excluded customers',
      facebookUrl: 'Facebook',
      footerImage: 'Image',
      footerUrl: 'Image URL',
      instagramUrl: 'Instagram',
      language: 'Language',
      languageCode: 'Language code',
      linkedinUrl: 'LinkedIn',
      noEmailTemplatesToDisplay: 'No email templates to display...',
      noExcludedCustomers: 'No excluded customers',
      phone: 'Phone number',
      removeEmailTemplateErrorText: 'Deleting the email template failed - please try again.',
      removeEmailTemplateSuccessText: 'The selected email template has been deleted.',
      removeEmailTemplateSuccessTitle: 'Template removed',
      removeEmailTemplteConfirmTitle: 'Are you sure you want to delete this email template?',
      url: 'WWW',
      youtubeUrl: 'YouTube'
    },
    integrations: {
      disabled: 'Integration disabled',
      disableIntegration: 'Disable integration',
      enabled: 'Integration enabled',
      enableIntegration: 'Enable integration',
      integrationHasBeenDisabled: 'Integration has been disabled',
      integrationHasBeenEnabled: 'Integration has been enabled',
      integrationIsDisabled: 'Integration is disabled',
      integrations: 'Integrations',
      name: 'Integration name',
      noIntegrationsToDisplay: 'No integrations to display',
      status: 'Integration status'
    },
    language: {
      addingTranslationsAvailableAfterSave: 'Please save the language to add translations',
      addLanguage: 'Add language',
      addLanguageErrorText: 'Adding language failed. Please try again.',
      addLanguageSuccessText: 'The specified language has been added',
      addLanguageSuccessTitle: 'Language added',
      addNewLanguage: 'Add a new language',
      chooseLanguage: 'Select language',
      editLanguage: 'Edit the language',
      editLanguageErrorText: 'Failed to edit the language. Please try again.',
      editLanguageSuccessText: 'The specified language has been changed',
      editLanguageSuccessTitle: 'Language modified',
      languageCode: 'Language code',
      languageLocative: 'language',
      languageName: 'Name of the language',
      languages: 'Languages',
      languagesLocative: 'languages',
      noLanguagesAvailable: 'No languages available',
      noLoanguagesToDisplay: 'No languages to display',
      noTranslationsForThisLanguage: 'No language translations to display',
      removeLanguageConfirmTitle: 'Are you sure you want to delete this language?',
      removeLanguageErrorText: 'Language removal failed. Please try again.',
      removeLanguageSuccessText: 'The specified language has been removed',
      removeLanguageSuccessTitle: 'Language deleted',
      translations: 'Translations'
    },
    orderTags: {
      addNewOrderTag: 'Add a new order tag',
      addOrderTag: 'Add a order tag',
      addOrderTagErrorText: 'Adding a order tag has failed. Please try again.',
      addOrderTagSuccessText: 'Order tag has been added',
      addOrderTagSuccessTitle: 'Order tag added',
      editOrderTag: 'Edit order tag',
      editOrderTagErrorText: 'Editing a order tag has failed. Please try again.',
      editOrderTagSuccessText: 'The specified order tag has been changed',
      editOrderTagSuccessTitle: 'Order tag modified',
      noTagsToDisplay: 'No order tags to display',
      ordersTags: 'Orders tags',
      orderTags: 'Order tags',
      removeTagConfirmTitle: 'Are you sure you want to delete this order tag?',
      removeTagErrorText: 'Order tag removal failed. Please try again.',
      removeTagSuccessText: 'The specified order tag has been removed',
      removeTagSuccessTitle: 'Order tag removed',
      tagColor: 'Tag colour',
      tagDescription: 'Tag description',
      taggedOrders: 'Orders count',
      tagName: 'Name of tag',
      tagNameAndDescription: 'Tag name and description'
    },
    phraseSearchPlaceholder: 'Enter text fragment to search',
    processingTime: {
      addingTranslationsAvailableAfterSave: 'Save processing time to add translations',
      addNewProcessingTime: 'Add a new lead time',
      addProcessingTime: 'Add lead time',
      addProcessingTimeErrorText: 'Adding lead time failed. Please try again.',
      addProcessingTimeSuccessText: 'The specified lead time has been added',
      addProcessingTimeSuccessTitle: 'Lead time added',
      editProcessingTime: 'Edit lead time',
      editProcessingTimeErrorText: 'Failed to edit the lead time. Please try again.',
      editProcessingTimeSuccessText: 'The selected lead time has been changed',
      editProcessingTimeSuccessTitle: 'Lead time modified',
      noProcessingTimesToDisplay: 'No lead times to display',
      noTranslationsForThisProcessingTime: 'No translations to display',
      processingTimeName: 'Name of lead time',
      processingTimes: 'Lead times',
      removeProcessingTimeConfirmTitle: 'Are you sure you want to delete this lead time?',
      removeProcessingTimeErrorText: 'Deletion of lead time failed. Please try again.',
      removeProcessingTimeSuccessText: 'The selected lead time has been deleted',
      removeProcessingTimeSuccessTitle: 'Lead time removed',
      translations: 'Translations'
    },
    regions: {
      allRegions: 'All regions',
      region: 'Region',
      selectRegion: 'Select region'
    },
    settingsLabel: 'Settings',
    source: {
      addNewSource: 'Add a new source',
      addNewSourceOfGain: 'Add a new acquisition source',
      addSourceErrorText: 'Adding a acquisition source has failed. Please try again.',
      addSourceOfGain: 'Add source of acquisition',
      addSourceSuccessText: 'The specified source of acquisition has been added',
      addSourceSuccessTitle: 'Source of acquisition added',
      editSourceErrorText: 'Failed to edit the source of acquisition. Please try again.',
      editSourceOfGain: 'Edit source of acquisition',
      editSourceSuccessText: 'The selected source has been changed',
      editSourceSuccessTitle: 'The source has been modified',
      noSourcesToDisplay: 'No source to display',
      sourceName: 'Name of source of acquisition',
      sources: 'Source of acquisition',
      sourcesDeleteConfirmTitle: 'Are you sure you want to delete this source?',
      sourcesDeleteErrorText: 'Source removal failed. Please try again.',
      sourcesDeleteSuccessText: 'The selected source has been deleted',
      sourcesDeleteSuccessTitle: 'Source removed'
    },
    systemSettings: 'CRM system settings',
    transaltion: {
      addTranslation: 'Add translation',
      addTranslationErrorText: 'Adding a translation failed. Please try again.',
      addTranslationSuccessText: 'The specified translation has been saved',
      addTranslationSuccessTitle: 'Translation added',
      deleteTranslationConfirmTitle: 'Are you sure you want to delete this translation?',
      deleteTranslationErrorText: 'Translation removal failed. Please try again.',
      deleteTranslationSuccessText: 'The selected translation has been deleted',
      deleteTranslationSuccessTitle: 'Translation removed',
      dictionaryMultilang: 'Dictionaries of multilingualism',
      editTranslation: 'Edit the translation',
      missingTranslationsIn: 'No translations in ',
      noTranslationsToDisplay: 'No translations to display',
      systemName: 'System name',
      transaltionStatus: 'Status of translations',
      translated: 'Translated',
      translation: 'Translation',
      translationEditErrorText: 'Failed to edit the translation. Please try again.',
      translationEditSuccessText: 'The selected translation has been changed',
      translationEditSuccessTitle: 'Translation modified',
      translations: 'Translations',
      valueInPolish: 'Value in Polish'
    },
    userGroups: {
      addNewUserGroup: 'Add new group',
      addUserGroupErrorText: 'Failed to add a new user group',
      addUserGroupSuccessText: 'Successfully added a new user group',
      addUserGroupSuccessTitle: 'New group added',
      editUserGroup: 'Edit user group',
      editUserGroupErrorText: 'Failed to modify the selected user group',
      editUserGroupSuccessText: 'Successfully modified the user group',
      editUserGroupSuccessTitle: 'Group modified',
      groupName: 'Group name',
      noUserGroupsToDisplay: 'No groups to display',
      removeUserGroupConfirmTitle: 'Are you sure you want to remove the selected user group?',
      removeUserGroupErrorText: 'Failed to remove the selected user group',
      removeUserGroupSuccessText: 'The selected user group has been removed',
      removeUserGroupSuccessTitle: 'Group removed',
      userGroup: 'User group',
      userGroups: 'User groups'
    }
  },
  settlements: {
    addSettlement: 'Add settlement',
    amount: 'Amount',
    changeToPaid: 'Change to paid',
    changeToUnpaid: 'Change to unpaid',
    deadlines: 'Deadlines',
    debtReport: {
      addNote: 'Add note',
      amountNet: 'Net Amount',
      count: 'Number of settlements',
      customer: 'Customer',
      dates: 'Dates',
      debtCalculated: 'Calculated Value',
      debtOriginal: 'Original Value',
      debtPaid: 'Paid Amount',
      downloadXlsx: 'Download XLSX',
      editNote: 'Edit note',
      exchange: 'Exchange Rate as of ',
      fileName: 'debt-report',
      hideSettlements: 'Hide Settlements',
      invoiceDate: 'Settlement Date',
      invoiceNumber: 'Document number',
      order: 'Order',
      paymentDate: 'Payment Due Date',
      percentage: 'Share %',
      seeSettlements: 'Settlements',
      showSettlements: 'Show Settlements',
      title: 'Debt Report',
      total: 'Total',
      type: 'Delay Type',
      types: {
        '30_DAYS': 'Invoices overdue 1-29 days',
        '60_DAYS': 'Invoices overdue 30-59 days',
        '90_DAYS': 'Invoices overdue 60-89 days',
        '90_PLUS_DAYS': 'Invoices overdue 90 days or more',
        'CURRENT': 'All issued invoices still within payment term'
      },
      yourNote: 'Note for this document'
    },
    deleteInvoiceRequest: 'Remove',
    downloadAllInvoices: 'Download all invoices',
    downloadFilteredInvoices: 'Download filtered invoices',
    downloadTodaysInvoices: 'Download today\'s invoices',
    errorOccuredDuringPrintout: 'An error occurred during requesting invoice printout',
    errorOccuredDuringRollback: 'An error occurred during undo operation',
    errorOccuredDuringSending: 'An error occurred during sending',
    invoiceList: 'List of invoices',
    invoicePrintout: 'Emergency printout of invoice',
    invoicePrintoutDesc: 'Printout will be available in a few minutes.',
    invoicePrintoutTitle: 'Generating printout has been requested in ERP',
    invoiceRollbackDesc: 'Selected invoice has been removed',
    invoiceRollbackTitle: 'Invoice removed',
    invoiceSent: 'Invoice sent',
    invoiceSentDesc: 'Invoice has been sent',
    invoiceSentTitle: 'Invoice sent',
    invoiceUnableToSent: 'Cannot send',
    issued: 'Issued',
    noSettlementsToDisplay: 'No settlements to display',
    paymentDueDate: 'Payment until',
    reminders: {
      active: 'Active',
      disable: 'Disable',
      enable: 'Enable',
      inactive: 'Inactive',
      status: 'Reminders'
    },
    sendEmail: 'Send email with invoice',
    sendEmailToCustomer: 'To customer',
    sendEmailToUser: 'To representative',
    sendInvoice: 'Send invoice',
    settle: 'Settle',
    settled: 'Settled',
    settlement: 'Settlement',
    settlements: 'Settlements',
    statusChangedDesc: '',
    statusChangedTitle: 'Payment status changed',
    submitStatus: 'Submit status',
    type: 'Type',
    viewHistory: 'View history of operations',
    waitingForInvoice: 'Is waiting for the invoice file'
  },
  settlementsAddPopup: {
    addDesc: 'Settlement has been added',
    addTitle: 'Settlement added',
    amount: 'Amount',
    amountNet: 'Net amount',
    amountPaid: 'Amount paid',
    currency: 'Currency',
    customer: 'Customer',
    filePDF: 'PDF file',
    invoiceDate: 'Invoice date',
    number: 'Document number',
    order: 'Order number',
    paymentDate: 'Payment date',
    settlementDate: 'Settlement date',
    status: 'Status',
    statuses: {
      PAID: 'Paid',
      UNPAID: 'Unpaid'
    },
    title: 'Add settlement'
  },
  settlementsHistoryPopup: {
    createdAt: 'Operation date',
    noOperations: 'No operations to display...',
    operation: 'Operation',
    operations: {
      ADD: 'Invoice add',
      DELETE: 'Invoice deletion',
      GET_INVOICE_PRINTOUT: 'Printout generation',
      PAID: 'Mark as paid',
      UNPAID: 'Mark as unpaid'
    },
    title: 'History of actions on settlement',
    user: 'Made by'
  },
  shipments: {
    addNewShipmentPOD: 'Add Proof of Delivery',
    addNewShipmentUPS: 'Add new UPS shipment',
    cancelShipment: 'Cancel shipment',
    createdAt: 'Created',
    createdBy: 'Created by',
    downloadLabelForShipment: 'Label for shipment',
    downloadPodForShipment: 'Proof of delivery',
    enterCustomerName: 'Enter receiver name',
    enterOrderName: 'Enter order name',
    enterTrackingNumber: 'Enter tracking number',
    labelFilePrefix: 'order-label-',
    lackOfAddressContactData: 'No address/contact for shipment',
    lackOfAddressContactDataDesc: 'Before adding shipment, please set the address and contact person, then save the order.',
    noRelatedOrder: 'No related order',
    noShipmentsToDisplay: 'No shipments to display',
    noTrackings: 'No tracking statuses to display',
    packages: 'Packages',
    packagesCount: 'Packages count',
    packagesWeight: 'Packages weight',
    podFilePrefix: 'proof-of-delivery-',
    popups: {
      addPackage: 'Add package',
      addPOD: 'Add Proof of Delivery',
      addShipment: 'Add shipment',
      basicDataTitle: 'Basic information',
      bulkCloneAdd: 'Copy',
      bulkCloneError: 'Please provide integer number',
      bulkCloneText: 'How many copies do you want to create?',
      bulkCloneTitle: 'Copying packages',
      checkPostalCode: 'Check postal code',
      codAmount: 'Amount of COD',
      codCurrencyCode: 'COD Currency',
      emptyPackages: 'No packages',
      emptyPackagesDesc: 'You must add packages to shipment before saving.',
      howManyPackages: 'How many?',
      invalidShipper: 'Shipper not set',
      invalidShipperDesc: 'You must select shipper',
      isCOD: 'COD (cash on delivery)',
      noPackages: 'No packages',
      packageDescription: 'Description',
      packageReferenceNumber: 'Reference number',
      packagesDataTitle: 'Packages',
      packageWeight: 'Weight (in kg)',
      paymentDataTitle: 'Payment',
      podFile: 'Proof of Delivery',
      podSaved: 'PoD saved',
      podSavedDesc: 'Proof of Delivery successfully saved',
      podSaveError: 'An error occurred during saving PoD',
      postCodeExistDesc: 'Provided postal code exists in the selected country',
      postCodeExistsTitle: 'Postal code exists',
      postCodeMultipleExistsDesc: 'Provided postal code exists in the selected country and also in other countries: ',
      postCodeMultipleExistsTitle: 'Postal code exists',
      postCodeNotExistsDesc: 'Provided postal code not exists in the selected country',
      postCodeNotExistsTitle: 'Postal code not exist',
      receiverAddress: 'Address',
      receiverAttentionName: 'Receiver first name and last name',
      receiverBuilding: 'Building',
      receiverCity: 'City',
      receiverCountryCode: 'Country',
      receiverDataTitle: 'Receiver',
      receiverEmail: 'Receiver e-mail address',
      receiverLine2: 'Additional address 2',
      receiverLine3: 'Additional address 3',
      receiverLocale: 'Locale',
      receiverName: 'Receiver company name',
      receiverPhone: 'Receiver phone number',
      receiverPostalCode: 'Postal code',
      receiverStreet: 'Street',
      relatedOrder: 'Related order',
      saveErrorText: 'An error occurred during saving shipment',
      savePOD: 'Save Proof of Delivery',
      saveShipment: 'Save shipment',
      saveSuccessText: 'Shipment has been successfully saved',
      saveSuccessTitle: 'Shipment saved',
      saveTracking: 'Save tracking number',
      saveTrackingErrorText: 'An error occurred during saving tracking number',
      saveTrackingSuccessText: 'Tracking number has been successfully saved',
      saveTrackingSuccessTitle: 'Tracking number saved',
      selectAddress: 'Select receiver\'s address',
      selectCountry: 'Select country',
      selectCurrency: 'Select currency',
      selectService: 'Select service',
      selectShipper: 'Select shipper',
      serviceDataTitle: 'Service',
      setCustomerData: 'Use customer data',
      setShipper: 'Set shipper data',
      shipmentDescription: 'Shipment description',
      shipmentInfo: 'Shipment informations',
      shipmentTrackingStatus: 'Shipment status',
      shipper: 'Select UPS account',
      shipperAddress: 'Address',
      shipperAttentionName: 'Shipper first name and last name',
      shipperBuilding: 'Building',
      shipperCity: 'City',
      shipperCode: 'Shipper code',
      shipperCountryCode: 'Shipper country',
      shipperDataTitle: 'Shipper',
      shipperEmail: 'Shipper e-mail address',
      shipperLocale: 'Locale',
      shipperName: 'Shipper company name',
      shipperNumber: 'Shipper UPS account',
      shipperPhone: 'Shipper phone number',
      shipperPostalCode: 'Postal code',
      shipperStreet: 'Street',
      trackingNumber: 'Tracking number',
      upsService: 'UPS service',
      useAddress: 'Use address',
      useCOD: 'Cash on delivery?'
    },
    receiverData: 'Receiver data',
    relatedOrder: 'Related order',
    selectStatus: 'Select status',
    shipmentCancelError: 'An error occurred during cancelling shipment',
    shipmentCancelled: 'Shipment cancelled',
    shipmentCancelledDesc: 'Shipment has been cancelled',
    shipments: 'Shipments',
    shipmentsAvailableAfterSave: 'Shipments list will be available after saving order',
    shipmentsList: 'Shipments list',
    shipper: 'Shipper',
    shipperData: 'Shipper data',
    status: 'Status',
    statusDate: 'Status date',
    statuses: {
      cancelled: 'Cancelled',
      delivered: 'Delivered',
      error: 'Error',
      integrated: 'Integrated',
      new: 'New'
    },
    trackingNumber: 'Tracking number',
    trackingStatuses: {
      D: 'Delivered',
      I: 'In transit',
      M: 'Manifest Pickup',
      P: 'Pickup',
      X: 'Exception'
    },
    viewShipment: 'View shipment details'
  },
  shipmentsReports: {
    amount: 'Shipments',
    createdAt: 'Created',
    dateRange: 'Report date range',
    downloadReport: 'Download report',
    errorDuringGeneratingReport: 'An error occurred during generating report. Please try again.',
    lastChange: 'Last change',
    noReportsToDisplay: 'No reports',
    reports: 'Shipment reports',
    reportsList: 'List of shipment reports',
    status: 'Report status',
    statuses: {
      EMAIL_SENDING: 'Sending e-mail',
      ENDED: 'Ended',
      GENERATING_POD: 'Generating proofs of delivery',
      MERGING_FILES: 'Merging files',
      NEW: 'New',
      REMOVING_FILES: 'Removing files',
      ZIP_PACKING: 'Packing files'
    },
    type: 'Type',
    typeAll: 'All',
    typeWithoutReport: 'Without report',
    viewPopup: {
      invoice: 'Invoice',
      invoiceMerged: 'Connected',
      noShipments: 'No shipments connected to the report',
      pod: 'Proof of delivery',
      podGenerated: 'Generated',
      title: 'Shipments connected to the report'
    },
    viewRelatedShipments: 'View related shipments'
  },
  shippers: {
    addingNewShipper: 'Adding a shipper',
    addingPricesWillBeAvailableAfterShipperSave: 'Adding prices will be possible after saving the shipper',
    addNew: 'Add a new shipper',
    addNewShipper: 'Add shipper',
    addShipperErrorText: 'Adding a shipper has failed. Please try again.',
    addShipperSuccessText: 'The specified shipper has been saved',
    addShipperSuccessTitle: 'Shipper added',
    chooseShipper: 'Select shipper',
    deleteConfirmTitle: 'Are you sure you want to delete this shipper?',
    deleteErrorText: 'Deletion of shipper has failed. Please try again.',
    deleteSuccessText: 'The selected shipper has been removed',
    deleteSuccessTitle: 'Shipper removed',
    editShipper: 'Edit the shipper',
    editShipperErrorText: 'Failed to edit the shipper. Please try again.',
    editShipperSuccessText: 'The selected shipper has been changed',
    editShipperSuccessTitle: 'Shipper modified',
    noPrices: 'No prices',
    noShippersAvailable: 'No shippers available',
    noShippersToDisplay: 'No shippers to display',
    price: 'price',
    prices: 'prices',
    shipperName: 'Name of shipper',
    shipperQuestionMark: 'Maker?',
    shippersLabel: 'Shippers',
    shippersList: 'List of shippers',
    shippersSearchPlaceholder: 'Enter the shipper name or code'
  },
  softlab: {
    errorDescription: 'Error description',
    forceSoftlabDataUpdate: 'Force data update in Softlab',
    forceUpdateErrorText: 'Failed to force data update. Please try again.',
    forceUpdateSuccessTitle: 'Forced data update',
    orderImportToSoftlabError: 'Error during import of an order into Softlab',
    updatingData: 'Updating data...'
  },
  statistics: {
    invoice: 'Invoice',
    invoices: 'Invoices',
    noInvoices: 'No issued invoices'
  },
  stats: {
    avgRowTitle: 'Average',
    compareCustomers: 'Filter customers created in the selected period:',
    comparePeriods: 'Compare to:',
    downloadData: 'Download data',
    endedOrdersAmount: 'Ended orders amount',
    endedOrdersCount: 'Ended orders count',
    maxRowTitle: 'Maximum',
    minRowTitle: 'Minimum',
    offersAmount: 'Offers amount',
    offersCount: 'Offers count',
    offersToOrdersAmount: 'Offers transformed into orders amount',
    offersToOrdersCount: 'Offers transformed into orders count',
    ordersAmount: 'Orders amount',
    ordersCount: 'Orders count',
    settlementOrdersAmount: 'Settlement orders amount',
    settlementOrdersCount: 'Settlement orders count',
    statsFilename: 'statistics',
    subtitle: 'Company statistics',
    sumRowTitle: 'Sum',
    title: 'Statistics'
  },
  status: {
    cannotChangePurchaseStatusText: 'You have to set deadline and save the purchase before changing status to "waiting for products"',
    cannotChangePurchaseStatusTitle: 'Cannot change status',
    changeStatus: 'Change status',
    changeStatusConfirmText: 'All unsaved changes will be lost. Save them before changing status.',
    changeStatusConfirmTitle: 'Are you sure you want to change your status?',
    changeStatusErrorText: 'Status change failed. Please try again.',
    changeStatusSuccessText: 'The status has been changed',
    changeStatusSuccessTitle: 'Status changed',
    changeStatusToDeleteConfirmText: 'This status cannot be undone. Are you sure, that you want to cancel this order?',
    changeStatusToDeleteConfirmTitle: 'WARNING!',
    operationNotPermitted: 'Not permitted',
    operationNotPermittedDesc: 'This status cannot be changed.',
    purchaseStatusQuestionMark: 'Purchase status?',
    receivers: 'Receivers',
    reminderDate: 'Date of reminder',
    selectSatus: 'Select status',
    status: 'Status',
    statusInSewingRoom: 'Sewing room status',
    statusInSewingRoomQuestionMark: 'Sewing room status?',
    statusQuestionMark: 'Status?',
    yesChangeStatus: 'Yes, change status'
  },
  systemMessages: {
    addMessage: 'Add message',
    addMessageErrorText: 'An error occurred while adding the message. Please try again.',
    addMessageSuccessText: 'Message added successfully',
    addMessageSuccessTitle: 'Message added',
    addNewMessage: 'Add new message',
    editMessage: 'Edit message',
    editMessageErrorText: 'An error occurred while updating the message. Please try again.',
    editMessageSuccessText: 'Message updated successfully',
    editMessageSuccessTitle: 'Message updated',
    failedToLoad: 'Failed to load notifications.',
    markAsRead: 'Mark as read',
    messagesList: 'Messages list',
    noMessages: 'No messages.',
    noMessagesToDisplay: 'No messages to display',
    noNewMessages: 'No new messages.',
    noUsersSelected: 'No users selected.',
    removeMessageConfirmTitle: 'Are you sure you want to remove this message?',
    removeMessageErrorText: 'An error occurred while removing the message. Please try again.',
    removeMessageSuccessText: 'The selected message has been removed',
    removeMessageSuccessTitle: 'Message removed',
    sendToAllUsers: 'Send to all users',
    systemMessages: 'System messages',
    usersGroupsValidationError: 'You must add at least one group or user.'
  },
  ui: {
    actionFailedTryAgain: 'The action has failed. Please try again.',
    actions: 'Actions',
    add: 'Add',
    addDescription: 'Add description',
    addDescriptionForCustomer: 'Add description for customer',
    additionalInfo: 'Additional notes',
    addNew: 'Add new',
    address: 'Address',
    addToOffer: 'Add to offer',
    amount: 'Quantity',
    availability: 'Availability',
    back: 'Back',
    backToList: 'Back to list',
    cancel: 'Cancel',
    chooseDate: 'Select date',
    chooseOption: 'Choose an option',
    clearFilter: 'Clear the filter',
    close: 'Close',
    code: 'Code',
    comments: 'Notes',
    companyName: 'Company name',
    contactPerson: 'Contact person',
    content: 'Content',
    created: 'Created',
    customerOrder: 'Partner order',
    customerOrders: 'Partner orders',
    customerOrdersList: 'List of partner orders',
    dataLoading: 'Data loading in progress',
    dataLoadingFailed: 'Data loading failed.',
    days: 'days',
    daysOfWeek: {
      fri: 'Fri',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thur: 'Thu',
      tue: 'Tue',
      wed: 'Wed'
    },
    deadline: 'Deadline',
    deadlineCap: 'DEADLINE',
    delete: 'Delete',
    deleteConfirmText: 'This operation cannot be undone',
    deliveryDate: 'Delivery date',
    description: 'Description',
    deselectAll: 'Deselect all',
    download: 'Download',
    downloadInProgress: 'Download in progress',
    duplicate: 'Duplicate',
    edit: 'Edit',
    emailAddress: 'E-mail address',
    eMailCap: 'E-mail',
    eMailShort: 'e-mail',
    errorOccured: 'An error occurred',
    errorOccuredDesc: 'Unexpected error occurred - please try again.',
    errorOccuredDuringDownload: 'An error occurred while downloading',
    errorOccuredDuringSending: 'An error occurred during sending',
    exportErrorTitle: 'An error occurred during export',
    file: 'File',
    from: 'from',
    generalInfo: 'General data',
    goTo: 'Go to...',
    immediate: 'immediate',
    importErrorTitle: 'An error occurred during import',
    importFile: 'Import file',
    importType: 'Type of import',
    inquiries: 'Inquiries',
    inquiry: 'Inquiry',
    invoiceCannotSent: 'Cannot send',
    invoiceDate: 'Invoice date',
    invoiceIsSent: 'Sent',
    invoiceIsSentQuestion: 'Invoice sent?',
    invoiceNotSent: 'Not sent',
    invoiceNumber: 'Invoice number',
    isSettled: 'Settled?',
    lack: 'None',
    language: 'Language',
    lastContactAt: 'Last contact',
    loadError: 'LOAD ERROR OCCURRED',
    maximum: 'Maximally',
    minimum: 'Minimally',
    monthNames: {
      apr: 'Apr',
      aug: 'Aug',
      dec: 'Dec',
      feb: 'Feb',
      jan: 'Jan',
      jul: 'Jul',
      jun: 'Jun',
      mar: 'Mar',
      may: 'May',
      nov: 'Nov',
      oct: 'Oct',
      sep: 'Wrz'
    },
    move: 'Move',
    name: 'Name',
    nameAndSurename: 'Name and surname',
    no: 'No',
    noAvailabilityData: 'No availability data',
    noAvailableValues: 'No values available',
    noInfoToDisplay: 'No information to display',
    noOptionsAvailable: 'No options available',
    noResults: 'No results',
    notSettled: 'Unsettled',
    offer: 'Offer',
    ok: 'OK',
    order: 'Order',
    orderName: 'Order name',
    orderNameNotes: 'Additional note',
    pagination: {
      itemsAmount: 'Number of items:'
    },
    pdf: 'PDF',
    perUnit: 'per unit',
    phoneShort: 'tel.',
    pieces: 'Pieces',
    piecesAbbr: 'pcs.',
    piecesAmount: 'Number of pieces',
    productsGenitive: 'Products',
    purchaseInvoiceEmail: 'E-mail used to send invoice requests',
    range: 'Range',
    refreshPage: 'Refresh page',
    repeatPassword: 'Repeat password',
    resetFilters: 'Reset filters',
    save: 'Save',
    saveChanges: 'Save changes',
    saveChangesErrorText: 'Saving changes failed. Try again.',
    saved: 'Saved',
    saveErrorTitle: 'Error while saving',
    saving: 'Saving',
    search: 'Search',
    searchFrom: ' search from ',
    searching: 'Search in progress',
    searchTo: ' to ',
    selectAll: ' Select all',
    selectContactPerson: 'Select a contact person',
    selectedPersonNotFound: 'Selected person not found',
    selectFile: 'Select file',
    selectSubSupplier: 'Select maker 1',
    selectSupplier: 'Select maker 2',
    sendPurchaseInvoiceEmail: 'Send e-mail with invoice request',
    settled: 'Settled',
    shipper: 'Shipper',
    shortDescription: 'Short description',
    showAll: 'Show all',
    subSupplier: 'Maker 1',
    supplier: 'Maker 2',
    supplierAlt: 'Supplier',
    supplierProductsReminderEmail: 'E-mail for sending reminders about product supply',
    tags: 'Tags',
    thisFieldIsRequired: 'This field is required',
    title: 'Title',
    to: 'to',
    toCap: 'To',
    toTryAgain: 'to try again.',
    tryAgain: 'Try again',
    updatedAt: 'Update date',
    value: 'Value',
    viewInNewTab: 'View in new tab',
    warning: 'Attention!',
    xls: 'XLS',
    xlsx: 'XLSX',
    yes: 'Yes',
    yesChange: 'Yes, change',
    yesRemove: 'Yes, delete',
    yesUpdate: 'Yes, update'
  },
  users: {
    accountActive: 'Active account',
    accountInactive: 'Inactive account',
    accountType: 'Account type',
    active: 'Active',
    addExcludedCustomer: 'Add excluded customer',
    addingNewUser: 'Adding a new user',
    addUser: 'Add user',
    addUserErrorText: 'Adding a user has failed. Please try again.',
    addUserSuccessText: 'The specified user has been saved',
    addUserSuccessTitle: 'User added',
    admin: 'Administrator',
    any: 'Any',
    assign: 'Assign',
    customer: 'Customer',
    customerNotSelectedErrorText: 'You must select the customer associated with this account',
    customerTaxNumber: 'NIP/VAT ID',
    customerTaxNumberFromRegister: 'NIP/VAT ID provided during registration',
    deleteConfirmTitle: 'Are you sure you want to delete this user?',
    deleteErrorText: 'User deletion failed. Please try again.',
    deleteSuccessText: 'The selected user has been deleted',
    deleteSuccessTitle: 'User deleted',
    editUser: 'User edit',
    editUserErrorText: 'Failed to edit the user. Please try again.',
    editUserSuccessText: 'The selected user has been changed',
    editUserSuccessTitle: 'User modified',
    excludedCustomers: 'Excluded customers',
    excludedCustomersList: 'List of excluded customers',
    inactive: 'Inactive',
    isAccountActive: 'Account active?',
    loggedInAs: 'Logged in as',
    noExcludedCustomers: 'No excluded customers',
    noUsersMatchingPhrase: 'TNo employees matching the given phrase',
    noUsersToDisplay: 'No users to display',
    orderTags: 'Tags added during creation of new order',
    pinCode: 'PIN for login',
    realWarehouseman: 'Warehouseman',
    selectWorker: 'Select employee',
    sendSalesReport: 'Send sales report',
    uiLanguage: 'UI language',
    uiLanguageEnglish: 'English',
    uiLanguagePolish: 'Polish',
    user: 'User',
    userName: 'User name',
    usersLabel: 'Users',
    usersList: 'Users list',
    usersSearchPlaceholder: 'Enter the user\'s first name, last name or email',
    warehouseman: 'Warehouse manager',
    worker: 'Employee',
    workerAssingErrorText: 'Failed to assign employee to order',
    workerAssingErrorTitle: 'Employee assignment failed',
    workerAssingSuccessText: 'Successfully reassigned employee to order',
    workerAssingSuccessTitle: 'Employee assigned',
    youMustSelectCustomerDesc: 'You must select customer to exclude',
    youMustSelectCustomerTitle: 'Please select customer to exclude'
  },
  validation: {
    checkRequired: 'This box must be checked.',
    fieldCanContainAtLeast1Char: 'This field must contain at least one character',
    fieldCanContainAtLeast24Chars: 'This field must contain at least {min} characters',
    fieldCanContainAtLeastNChars: 'This field must contain at least {min} characters',
    fieldCanContainAtMax1Char: 'This field can contain a maximum of one character',
    fieldCanContainAtMax24Chars: 'This field can contain up to {max} characters',
    fieldCanContainAtMaxNChars: 'This field can contain up to {max} characters',
    onlyBigLetters: 'This field can only contain capital letters',
    onlyLettersAndDashes: 'This field can only contain letters and hyphens',
    onlyLettersAndNumbers: 'This field can only contain letters and numbers',
    onlyNumbers: 'This field must contain a number',
    passwordsAreNotIdentical: 'Passwords do not match',
    postalCodePl: 'Input valid postal code in format XX-XXX',
    required: 'This field is required',
    requiredDateRange: 'Date range is required',
    validDoubleNumericRequired: 'Required number in format 123.45',
    validEmailRequired: 'This field must contain a valid e-mail address',
    validUrlRequired: 'This field must contain a valid URL',
    valueCannotBeGreaterThan: 'The value cannot be greater than ',
    valueCannotBeLessThan: 'The value cannot be less than ',
    valueMustContainOrderID: 'Order name must contain ID of the order: ',
    youMustSelectValue: 'You have to choose a value'
  },
  welcome: {
    baseballCaps: 'Baseball caps',
    capVizors: 'Peaks',
    choose: 'Select',
    clear: 'Clear',
    clientPanel: 'Customer Panel',
    companyName: 'Headwear',
    filter: 'Filter',
    filterAvailability: 'Filter availability',
    filterByNameOrCode: 'Filter by name/code',
    filterByPrice: 'Filter by price',
    hats: 'Hats',
    noProductsInSearchCriteria: 'No products meeting your criteria',
    addToList: 'Add to list',
    removeFromList: 'Remove from list',
    productUnavailable: 'Product unavailable',
    selectedProducts: 'Selected products',
    noSelectedProducts: 'No products selected yet',
    addSelectedProducts: 'Add selected',
    orderInfo: 'Send inquiries for an offer or fulfil orders <span class="text-primary font-weight-bold">in 5 easy steps</span>:',
    orderWithAdditionInfo: '<i class="material-icons text-danger">info</i> In case of orders with services, your inquiry will be forwarded to our sales department. We will prepare an offer that you will be able to approve in this panel in the tab <span class="font-weight-bold">"Inquiries"</span>. The inquiries for approval will have a status <span class="font-weight-bold">"For approval"</span>.',
    orderWithNoAdditionInfo: '<i class="material-icons text-danger">info</i> If you want to order caps without additional services: click the button <span class="font-weight-bold">"Add an order"</span> - Your order will go into production immediately.',
    productBrowserInfo: 'Use our <span class="font-weight-bold">product finder</span>. You will find photos of products, price and inventory. You can also start creating an inquiry from the search engine. Just click on the product <span class="font-weight-bold">"Add to offer"</span> - you will be redirected to the offer creation form and the first product will immediately appear in the inquiry.',
    requireAll: 'Require all',
    searchProducts: 'Search for a product',
    setp: 'Step',
    stepFiveContent: 'Click the button <span class="font-weight-bold">"Send inquiry"</span> or <span class="font-weight-bold">"Add an order"',
    stepFourContent: 'Under the tab <span class="font-weight-bold">"General data"</span> fill in your delivery and contact details',
    stepOneContent: 'Go to tab <span class="font-weight-bold">"Inquiries"</span>',
    stepThreeContent: 'Under the tab <span class="font-weight-bold">"Inquiry"</span> select products and services',
    stepTwoContent: 'Click the button <span class="font-weight-bold">"Add new inquiry"</span>',
    wantToCheckOurProducts: 'Do you want to quickly check our products and prices?',
    welcomeToClientPanel: 'Welcome to the HeadWear customer panel',
    winterHats: 'Winter hats'
  }
};
